// Finn poenggrensene her: https://rapport-dv.uhad.no/t/SO-datavarehus/views/Poenggrenserventelistetallogskeremedtilbudperkvote_Hovedopptaket2023/Poenggrenser?%3Aembed=y&%3AisGuestRedirectFromVizportal=y
// Bruk en CSV til JSON converter for å få dataen inn i riktig format (Husk å sjekke overskriftene)

const fieldsOfStudy = [
  {
    Studiekode: '150 172',
    Studienavn: 'Friluftsliv',
    Studiekategori: 'Årsstudium',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 51.9,
    ORDF: 39,
  },
  {
    Studiekode: '150 185',
    Studienavn: 'Treningslære',
    Studiekategori: 'Årsstudium',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 51.5,
    ORDF: 42.6,
  },
  {
    Studiekode: '150 485',
    Studienavn: 'Trening, helse og prestasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 51,
    ORDF: 45.7,
  },
  {
    Studiekode: '150 486',
    Studienavn: 'Sport Management',
    Studiekategori: 'Bachelor',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 52.1,
    ORDF: 47.5,
  },
  {
    Studiekode: '150 489',
    Studienavn: 'Trenerrollen og idrettspsykologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 53,
    ORDF: 47.7,
  },
  {
    Studiekode: '150 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og idrettsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 49.7,
    ORDF: 47.8,
  },
  {
    Studiekode: '150 583',
    Studienavn: 'Organisasjon og idrettsledelse , deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 56.5,
    ORDF: 35.4,
  },
  {
    Studiekode: '150 605',
    Studienavn: 'Friluftsliv, helse og naturguiding',
    Studiekategori: 'Bachelor',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 40.3,
    ORDF: 0,
  },
  {
    Studiekode: '150 649',
    Studienavn: 'Idrett og samfunn',
    Studiekategori: 'Årsstudium',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 47.5,
    ORDF: 40,
  },
  {
    Studiekode: '184 074',
    Studienavn: 'Norrøn filologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 162',
    Studienavn: 'Politikk og forvaltning, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 170',
    Studienavn: 'Engelsk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 174',
    Studienavn: 'Fransk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 188',
    Studienavn: 'Informatikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 59,
    ORDF: 0,
  },
  {
    Studiekode: '184 189',
    Studienavn: 'Informasjonsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.3,
    ORDF: 42.7,
  },
  {
    Studiekode: '184 200',
    Studienavn: 'Kulturvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 211',
    Studienavn: 'Nordisk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORD: 57.5,
    ORDF: 45.2,
  },
  {
    Studiekode: '184 222',
    Studienavn: 'Kjønn, seksualitet og mangfold',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 238',
    Studienavn: 'Sammenliknende politikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 47.5,
    ORDF: 43.9,
  },
  {
    Studiekode: '184 239',
    Studienavn: 'Samfunnsøkonomi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 53,
    ORDF: 48,
  },
  {
    Studiekode: '184 240',
    Studienavn: 'Sosiologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 50.8,
    ORDF: 45.9,
  },
  {
    Studiekode: '184 244',
    Studienavn: 'Tysk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 248',
    Studienavn: 'Geografi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 272',
    Studienavn: 'Kunsthistorie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 306',
    Studienavn: 'Informatikk-matematikk-økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 53.8,
    ORDF: 50.3,
  },
  {
    Studiekode: '184 327',
    Studienavn: 'Biologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 366',
    Studienavn: 'Filosofi',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 367',
    Studienavn: 'Sosialantropologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 47,
    ORDF: 44.3,
  },
  {
    Studiekode: '184 369',
    Studienavn: 'Samfunnsøkonomi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 51.8,
    ORDF: 49,
  },
  {
    Studiekode: '184 395',
    Studienavn: 'Informatikk: bioinformatikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.8,
    ORDF: 48.6,
  },
  {
    Studiekode: '184 430',
    Studienavn: 'Medie- og interaksjonsdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 58.5,
    ORDF: 51,
  },
  {
    Studiekode: '184 437',
    Studienavn: 'Musikkvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 50.3,
    ORDF: 44.2,
  },
  {
    Studiekode: '184 438',
    Studienavn: 'Geografi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 453',
    Studienavn: 'Informasjonsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 53.3,
    ORDF: 44.7,
  },
  {
    Studiekode: '184 454',
    Studienavn: 'Journalistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 58,
    ORDF: 53.8,
  },
  {
    Studiekode: '184 455',
    Studienavn: 'Klassisk filologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 472',
    Studienavn: 'Digital kultur',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 475',
    Studienavn: 'Kunsthistorie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 478',
    Studienavn: 'Arkeologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 479',
    Studienavn: 'Filosofi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 499',
    Studienavn: 'Medisin, Bergen/Stavanger',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 67.1,
    ORDF: 58.5,
  },
  {
    Studiekode: '184 534',
    Studienavn: 'Film- og TV-produksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 58.3,
    ORDF: 52.4,
  },
  {
    Studiekode: '184 540',
    Studienavn: 'Aktuarfag og dataanalyse',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 555',
    Studienavn: 'Anvendt matematikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 565',
    Studienavn: 'Italiensk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 580',
    Studienavn: 'Lektor, 8.-13. trinn, religionsvitenskap',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 582',
    Studienavn: 'Japansk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 585',
    Studienavn: 'Data science (sivilingeniør)',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 56.1,
    ORDF: 53.5,
  },
  {
    Studiekode: '184 592',
    Studienavn: 'Kinesisk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 663',
    Studienavn: 'Medier og kommunikasjon, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 54,
    ORDF: 45.2,
  },
  {
    Studiekode: '184 670',
    Studienavn: 'Naturvitenskapelige fag',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 684',
    Studienavn: 'Lektor, 8.-13. trinn, historie',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 686',
    Studienavn: 'Lektor, 8.-13. trinn, fransk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '184 689',
    Studienavn: 'Lektor, 8.-13. trinn, tysk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '184 692',
    Studienavn: 'Teatervitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 698',
    Studienavn: 'Samfunnsøkonomi, master',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 53.5,
    ORDF: 50.1,
  },
  {
    Studiekode: '184 707',
    Studienavn: 'Farmasi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - FARMASI',
    ORD: 52.8,
    ORDF: 49.4,
  },
  {
    Studiekode: '184 708',
    Studienavn: 'Ernæring',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 711',
    Studienavn: 'Havbruk (sivilingeniør)',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 55.5,
    ORDF: 49.7,
  },
  {
    Studiekode: '184 724',
    Studienavn: 'Rettsvitenskap',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'JUS',
    ORD: 62.4,
    ORDF: 55.1,
  },
  {
    Studiekode: '184 740',
    Studienavn: 'Medisin, Bergen',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 67.8,
    ORDF: 59.4,
  },
  {
    Studiekode: '184 742',
    Studienavn: 'Odontologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 65.4,
    ORDF: 57.3,
  },
  {
    Studiekode: '184 743',
    Studienavn: 'Tannpleie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 49.2,
    ORDF: 46,
  },
  {
    Studiekode: '184 752',
    Studienavn: 'Psykologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 53.1,
    ORDF: 49.2,
  },
  {
    Studiekode: '184 765',
    Studienavn: 'Havteknologi (sivilingeniør)',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 53.9,
    ORDF: 51.9,
  },
  {
    Studiekode: '184 769',
    Studienavn: 'Energi (sivilingeniør)',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 54.9,
    ORDF: 52.3,
  },
  {
    Studiekode: '184 783',
    Studienavn: 'Medisinsk teknologi (sivilingeniør)',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 61,
    ORDF: 57.5,
  },
  {
    Studiekode: '184 792',
    Studienavn: 'Musikkterapi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 803',
    Studienavn: 'Informasjonsteknologi og økonomi (sivilingeniør)',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 62.5,
    ORDF: 58.8,
  },
  {
    Studiekode: '184 817',
    Studienavn: 'Lektor, 8.-13. trinn, nordisk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 827',
    Studienavn: 'Fiskehelse - akvamedisin',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 56.4,
    ORDF: 50.1,
  },
  {
    Studiekode: '184 829',
    Studienavn: 'Informatikk: datateknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 56.1,
    ORDF: 47.4,
  },
  {
    Studiekode: '184 832',
    Studienavn: 'Kunstig intelligens',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 56,
    ORDF: 48.6,
  },
  {
    Studiekode: '184 837',
    Studienavn: 'Kognitiv vitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 56.5,
    ORDF: 50.7,
  },
  {
    Studiekode: '184 843',
    Studienavn: 'Lektor, 8.-13. trinn, naturvit. eller matematikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 844',
    Studienavn: 'Lektor, 8.-13. trinn, engelsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 851',
    Studienavn: 'Medier og kommunikasjon, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 47.9,
    ORDF: 46.3,
  },
  {
    Studiekode: '184 852',
    Studienavn: 'Pedagogikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORD: 47.6,
    ORDF: 43.5,
  },
  {
    Studiekode: '184 853',
    Studienavn: 'Spesialpedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORD: 53.8,
    ORDF: 47.4,
  },
  {
    Studiekode: '184 857',
    Studienavn: 'Fysikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 858',
    Studienavn: 'Geofag og informatikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 48.6,
    ORDF: 46.8,
  },
  {
    Studiekode: '184 859',
    Studienavn: 'Geovitenskap, retning geologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 49.2,
    ORDF: 46.8,
  },
  {
    Studiekode: '184 860',
    Studienavn: 'Kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 862',
    Studienavn: 'Matematikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 865',
    Studienavn: 'Molekylærbiologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 48.6,
    ORDF: 47.9,
  },
  {
    Studiekode: '184 867',
    Studienavn: 'Politikk og forvaltning, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 870',
    Studienavn: 'Europastudier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 42.6,
    ORDF: 43,
  },
  {
    Studiekode: '184 873',
    Studienavn: 'Kjønnsstudier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 876',
    Studienavn: 'Generell psykologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 58,
    ORDF: 53.5,
  },
  {
    Studiekode: '184 878',
    Studienavn: 'Sammenliknende politikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 47,
    ORDF: 46.2,
  },
  {
    Studiekode: '184 879',
    Studienavn: 'Sosialantropologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 880',
    Studienavn: 'Sosiologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 43.5,
    ORDF: 42.4,
  },
  {
    Studiekode: '184 886',
    Studienavn: 'Russisk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 887',
    Studienavn: 'Engelsk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 888',
    Studienavn: 'Fransk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 889',
    Studienavn: 'Nordisk språk og litteratur',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 890',
    Studienavn: 'Tysk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '184 893',
    Studienavn: 'Språkvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 903',
    Studienavn: 'Arbeids- og organisasjonspsykologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 57.9,
    ORDF: 53,
  },
  {
    Studiekode: '184 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 911',
    Studienavn: 'Norsk som andrespråk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 912',
    Studienavn: 'Spansk språk og latinamerikastudier, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 914',
    Studienavn: 'Statistikk og data science',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 915',
    Studienavn: 'Geovitenskap, retning geofysikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 52.5,
    ORDF: 49.4,
  },
  {
    Studiekode: '184 916',
    Studienavn: 'Vær, hav og klimafysikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 922',
    Studienavn: 'Litteraturvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 924',
    Studienavn: 'Spansk språk og latinamerikastudier, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 929',
    Studienavn: 'Religionsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 934',
    Studienavn: 'Lektor, 8.-13. trinn, sosiologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 50.5,
    ORDF: 49.6,
  },
  {
    Studiekode: '184 935',
    Studienavn: 'Lektor, 8.-13. trinn, spansk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '184 940',
    Studienavn: 'Informatikk: datasikkerhet',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 54.6,
    ORDF: 46.2,
  },
  {
    Studiekode: '184 941',
    Studienavn: 'Psykologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 66.5,
    ORDF: 57.5,
  },
  {
    Studiekode: '184 954',
    Studienavn: 'Norsk som andrespråk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 073',
    Studienavn: 'Idéhistorie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 52.2,
    ORDF: 0,
  },
  {
    Studiekode: '185 074',
    Studienavn: 'Norrøne og keltiske studier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 121',
    Studienavn: 'Kjernefysikk og nukleærteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 56,
    ORDF: 53.1,
  },
  {
    Studiekode: '185 170',
    Studienavn: 'Engelsk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 41,
    ORDF: 0,
  },
  {
    Studiekode: '185 174',
    Studienavn: 'Fransk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 49.2,
    ORDF: 0,
  },
  {
    Studiekode: '185 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 51.6,
    ORDF: 0,
  },
  {
    Studiekode: '185 187',
    Studienavn: 'Informatikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 52.5,
    ORDF: 0,
  },
  {
    Studiekode: '185 200',
    Studienavn: 'Kulturhistorie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 41.5,
    ORDF: 0,
  },
  {
    Studiekode: '185 205',
    Studienavn: 'Matematikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 211',
    Studienavn: 'Nordisk, særlig norsk, språk og litteratur',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 53,
    ORDF: 0,
  },
  {
    Studiekode: '185 212',
    Studienavn: 'Norsk som andrespråk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 51.9,
    ORDF: 0,
  },
  {
    Studiekode: '185 222',
    Studienavn: 'Tverrfaglige kjønnsstudier, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 60.1,
    ORDF: 39.5,
  },
  {
    Studiekode: '185 233',
    Studienavn: 'Realfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 237',
    Studienavn: 'Øst-Europa-studier',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 39.1,
    ORDF: 0,
  },
  {
    Studiekode: '185 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 55,
    ORDF: 46.7,
  },
  {
    Studiekode: '185 239',
    Studienavn: 'Samfunnsøkonomi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 61.1,
    ORDF: 47,
  },
  {
    Studiekode: '185 240',
    Studienavn: 'Sosiologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 57.2,
    ORDF: 46.3,
  },
  {
    Studiekode: '185 272',
    Studienavn: 'Kunsthistorie og visuelle studier, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 61.3,
    ORDF: 39.5,
  },
  {
    Studiekode: '185 308',
    Studienavn: 'Kultur og kommunikasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 50,
    ORDF: 43.2,
  },
  {
    Studiekode: '185 327',
    Studienavn: 'Biovitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 42.6,
    ORDF: 40.8,
  },
  {
    Studiekode: '185 340',
    Studienavn: 'Økonomi og datavitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 61,
    ORDF: 52.6,
  },
  {
    Studiekode: '185 366',
    Studienavn: 'Filosofi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 62.6,
    ORDF: 52.4,
  },
  {
    Studiekode: '185 370',
    Studienavn: 'Informatikk: digital økonomi og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 59.8,
    ORDF: 50.8,
  },
  {
    Studiekode: '185 381',
    Studienavn: 'Matematikk: finans, forsikring og økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 56.7,
    ORDF: 49,
  },
  {
    Studiekode: '185 400',
    Studienavn: 'Idéhistorie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 60.2,
    ORDF: 47.5,
  },
  {
    Studiekode: '185 437',
    Studienavn: 'Musikkvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 39.2,
    ORDF: 0,
  },
  {
    Studiekode: '185 438',
    Studienavn: 'Samfunnsgeografi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 49.7,
    ORDF: 42.7,
  },
  {
    Studiekode: '185 439',
    Studienavn: 'Estetikk, kunst og samfunn',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 452',
    Studienavn: 'Offentlig administrasjon og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 54.2,
    ORDF: 49.4,
  },
  {
    Studiekode: '185 459',
    Studienavn: 'Klassiske språk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 461',
    Studienavn: 'Midtøsten-studier med tyrkisk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 462',
    Studienavn: 'Kunsthistorie og visuelle studier, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 47.4,
    ORDF: 0,
  },
  {
    Studiekode: '185 464',
    Studienavn: 'Matematikk: teoretisk og anvendt matematikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 47.6,
    ORDF: 0,
  },
  {
    Studiekode: '185 465',
    Studienavn: 'Helseledelse og helseøkonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 56.4,
    ORDF: 45.7,
  },
  {
    Studiekode: '185 474',
    Studienavn: 'Honoursprogram, Samfunnsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 63.1,
    ORDF: 56.2,
  },
  {
    Studiekode: '185 478',
    Studienavn: 'Arkeologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 48.8,
    ORDF: 40.7,
  },
  {
    Studiekode: '185 479',
    Studienavn: 'Filosofi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 57.9,
    ORDF: 37.8,
  },
  {
    Studiekode: '185 480',
    Studienavn: 'Teologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 47.3,
    ORDF: 0,
  },
  {
    Studiekode: '185 482',
    Studienavn: 'Religion og samfunn',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 483',
    Studienavn: 'Russisk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 498',
    Studienavn: 'Medisin, Oslo/Kristiansand, høst',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 68.7,
    ORDF: 59,
  },
  {
    Studiekode: '185 499',
    Studienavn: 'Medisin, Oslo/Kristiansand, vår',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 68.3,
    ORDF: 58.7,
  },
  {
    Studiekode: '185 555',
    Studienavn: 'Matematikk: data, modellering og beregninger',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 49,
    ORDF: 0,
  },
  {
    Studiekode: '185 565',
    Studienavn: 'Italiensk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 580',
    Studienavn: 'Lektor, 8.-13. trinn, religion og etikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 582',
    Studienavn: 'Japansk med Japan-studier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 46.8,
    ORDF: 0,
  },
  {
    Studiekode: '185 588',
    Studienavn: 'Filosofi, politikk og økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 65,
    ORDF: 56.7,
  },
  {
    Studiekode: '185 592',
    Studienavn: 'Kinesisk med Kina-studier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 598',
    Studienavn: 'Midtøsten-studier med persisk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 604',
    Studienavn: 'Medier og kommunikasjon, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 54,
    ORDF: 39.2,
  },
  {
    Studiekode: '185 609',
    Studienavn: 'Antikkens kultur',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 57.4,
    ORDF: 35,
  },
  {
    Studiekode: '185 615',
    Studienavn: 'Allmenn litteraturvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 52.1,
    ORDF: 0,
  },
  {
    Studiekode: '185 626',
    Studienavn: 'Kristendom og islam',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 684',
    Studienavn: 'Lektor, 8.-13. trinn, historie',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 49.4,
    ORDF: 46.3,
  },
  {
    Studiekode: '185 685',
    Studienavn: 'Lektor, 8.-13. trinn, engelsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 690',
    Studienavn: 'Tysk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 39.7,
    ORDF: 0,
  },
  {
    Studiekode: '185 698',
    Studienavn: 'Samfunnsøkonomisk analyse',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 57.4,
    ORDF: 45.4,
  },
  {
    Studiekode: '185 707',
    Studienavn: 'Farmasi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - FARMASI',
    ORD: 49.6,
    ORDF: 41.9,
  },
  {
    Studiekode: '185 713',
    Studienavn: 'Klinisk ernæring',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: 56.4,
    ORDF: 0,
  },
  {
    Studiekode: '185 714',
    Studienavn: 'Honoursprogram, Humaniora, Musikkvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: -1,
  },
  {
    Studiekode: '185 715',
    Studienavn: 'Honoursprogram, Humaniora, Filosofi og lingvistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 49,
    ORDF: 48.2,
  },
  {
    Studiekode: '185 724',
    Studienavn: 'Rettsvitenskap (jus), høst',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'JUS',
    ORD: 64.5,
    ORDF: 56.4,
  },
  {
    Studiekode: '185 725',
    Studienavn: 'Rettsvitenskap (jus), vår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'JUS',
    ORD: 63.3,
    ORDF: 55.1,
  },
  {
    Studiekode: '185 740',
    Studienavn: 'Medisin, Oslo, høst',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 69.7,
    ORDF: 60.7,
  },
  {
    Studiekode: '185 742',
    Studienavn: 'Odontologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 66.3,
    ORDF: 57.2,
  },
  {
    Studiekode: '185 745',
    Studienavn: 'Medisin, Oslo, vår',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 68.4,
    ORDF: 59,
  },
  {
    Studiekode: '185 747',
    Studienavn: 'Honoursprogram, Realfag',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 63.2,
    ORDF: 60.9,
  },
  {
    Studiekode: '185 751',
    Studienavn: 'Kriminologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 62.2,
    ORDF: 53.5,
  },
  {
    Studiekode: '185 752',
    Studienavn: 'Psykologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 62,
    ORDF: 53.3,
  },
  {
    Studiekode: '185 771',
    Studienavn: 'Teologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 793',
    Studienavn: 'Fransk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 795',
    Studienavn: 'Tysk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: -1,
  },
  {
    Studiekode: '185 817',
    Studienavn: 'Lektor, 8.-13. trinn, norsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 829',
    Studienavn: 'Informatikk: programmering og systemarkitektur',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.7,
    ORDF: 44.7,
  },
  {
    Studiekode: '185 830',
    Studienavn: 'Informatikk: design, bruk og interaksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.1,
    ORDF: 45.8,
  },
  {
    Studiekode: '185 832',
    Studienavn: 'Informatikk: robotikk og intelligente systemer',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 53.4,
    ORDF: 40.6,
  },
  {
    Studiekode: '185 837',
    Studienavn: 'Informatikk: språkteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.3,
    ORDF: 43,
  },
  {
    Studiekode: '185 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 851',
    Studienavn: 'Medier og kommunikasjon, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 51,
    ORDF: 44.6,
  },
  {
    Studiekode: '185 852',
    Studienavn: 'Pedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'PEDFAG',
    ORD: 44.5,
    ORDF: 36.7,
  },
  {
    Studiekode: '185 853',
    Studienavn: 'Spesialpedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'PEDFAG',
    ORD: 46.9,
    ORDF: 39.1,
  },
  {
    Studiekode: '185 856',
    Studienavn: 'Elektronikk, informatikk og teknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 857',
    Studienavn: 'Fysikk og astronomi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 858',
    Studienavn: 'Geologi og geografi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 860',
    Studienavn: 'Kjemi og biokjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 863',
    Studienavn: 'Fornybar energi og nanoteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 872',
    Studienavn: 'Internasjonale studier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 59.5,
    ORDF: 54.8,
  },
  {
    Studiekode: '185 873',
    Studienavn: 'Tverrfaglige kjønnsstudier, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 44.7,
    ORDF: 0,
  },
  {
    Studiekode: '185 874',
    Studienavn: 'Kriminologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 60.5,
    ORDF: 53.8,
  },
  {
    Studiekode: '185 876',
    Studienavn: 'Psykologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 58.7,
    ORDF: 51.1,
  },
  {
    Studiekode: '185 879',
    Studienavn: 'Sosialantropologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 46,
    ORDF: 41.8,
  },
  {
    Studiekode: '185 880',
    Studienavn: 'Sosiologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 51.5,
    ORDF: 45.8,
  },
  {
    Studiekode: '185 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 55.7,
    ORDF: 51.1,
  },
  {
    Studiekode: '185 883',
    Studienavn: 'Utviklingsstudier og bærekraft',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 50.9,
    ORDF: 46.5,
  },
  {
    Studiekode: '185 889',
    Studienavn: 'Nordisk: språk, litteratur, retorikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 893',
    Studienavn: 'Lingvistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 44,
    ORDF: 0,
  },
  {
    Studiekode: '185 898',
    Studienavn: 'Samfunnsøkonomi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 60.5,
    ORDF: 50,
  },
  {
    Studiekode: '185 899',
    Studienavn: 'Tannpleie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 54,
    ORDF: 46.4,
  },
  {
    Studiekode: '185 901',
    Studienavn: 'Klart språk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 47.4,
    ORDF: 0,
  },
  {
    Studiekode: '185 904',
    Studienavn: 'Kulturarv- og konserveringsstudier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 59.1,
    ORDF: 0,
  },
  {
    Studiekode: '185 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 53.3,
    ORDF: 0,
  },
  {
    Studiekode: '185 912',
    Studienavn: 'Spansk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 50.5,
    ORDF: 0,
  },
  {
    Studiekode: '185 915',
    Studienavn: 'Geofysikk og klima',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 920',
    Studienavn: 'Engelsk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 922',
    Studienavn: 'Allmenn litteraturvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 923',
    Studienavn: 'Midtøsten-studier med arabisk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 52.1,
    ORDF: 0,
  },
  {
    Studiekode: '185 924',
    Studienavn: 'Spansk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 929',
    Studienavn: 'Religionsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 934',
    Studienavn: 'Lektor, 8.-13. trinn, samfunnsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 50.5,
    ORDF: 47.5,
  },
  {
    Studiekode: '185 935',
    Studienavn: 'Lektor, 8.-13. trinn, fremmedspråk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '185 941',
    Studienavn: 'Psykologi , høst',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 68.1,
    ORDF: 57.8,
  },
  {
    Studiekode: '185 942',
    Studienavn: 'Psykologi , vår',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 67,
    ORDF: 56.9,
  },
  {
    Studiekode: '185 950',
    Studienavn: 'Italiensk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 58.5,
    ORDF: 0,
  },
  {
    Studiekode: '186 002',
    Studienavn: 'Ingeniør, bærekraftig teknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 004',
    Studienavn: 'Ingeniør, datateknikk, Alta/Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 006',
    Studienavn: 'Ingeniør, elkraftteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 007',
    Studienavn: 'Ingeniør, droneteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 012',
    Studienavn: 'Ingeniør, maskin, Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 017',
    Studienavn: 'Ingeniør, automasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 021',
    Studienavn: 'Ingeniør, havteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 023',
    Studienavn: 'Ingeniør, bygg, Alta',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 024',
    Studienavn: 'Ingeniør, elektronikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 027',
    Studienavn: 'Ingeniør, satelitteknologi, Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 035',
    Studienavn: 'Økonomi og administrasjon, Harstad',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 049',
    Studienavn: 'Nautikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 050',
    Studienavn: 'Sykepleie, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 43.8,
    ORDF: 45.8,
  },
  {
    Studiekode: '186 051',
    Studienavn: 'Sykepleie, Hammerfest',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Hammerfest',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 055',
    Studienavn: 'Sykepleie, Harstad',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 056',
    Studienavn: 'Sykepleie, Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 064',
    Studienavn: 'Nordsamisk på morsmålsnivå, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 069',
    Studienavn: 'Ingeniør, maskin, Alta/Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 070',
    Studienavn: 'Barnevern, Alta',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 075',
    Studienavn: 'Ingeniør, bygg, Narvik, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 077',
    Studienavn: 'Ingeniør, prosessteknologi, Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 078',
    Studienavn: 'Ingeniør, datateknikk, Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 56.8,
    ORDF: 0,
  },
  {
    Studiekode: '186 080',
    Studienavn: 'Sosialt arbeid, Alta',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 38.2,
    ORDF: 0,
  },
  {
    Studiekode: '186 081',
    Studienavn: 'Sosialt arbeid, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 46.9,
    ORDF: 0,
  },
  {
    Studiekode: '186 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Tromsø',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Tromsø',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 130',
    Studienavn: 'Barnehagelærer, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 131',
    Studienavn: 'Barnehagelærer, Alta, samlingsbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 132',
    Studienavn: 'Barnehagelærer, Tromsø, samlingsbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 162',
    Studienavn: 'Praktisk prosjektledelse, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 164',
    Studienavn: 'Bedriftsøkonomi',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 170',
    Studienavn: 'Engelsk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 185',
    Studienavn: 'Idrett, Tromsø',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 205',
    Studienavn: 'Matematikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 211',
    Studienavn: 'Nordisk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 222',
    Studienavn: 'Likestilling og kjønn',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 224',
    Studienavn: 'Informatikk, Mo i Rana',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Herøy (Nordland)',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 225',
    Studienavn: 'Ingeniør, datateknikk, Bodø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Bodø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 235',
    Studienavn: 'Nordsamisk på morsmålsnivå, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 299',
    Studienavn: 'Bioteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 302',
    Studienavn: 'Arktisk friluftsliv og naturguiding',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 327',
    Studienavn: 'Biologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 331',
    Studienavn: 'Fiskeri- og havbruksvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 44.6,
    ORDF: 41.8,
  },
  {
    Studiekode: '186 336',
    Studienavn: 'Bibliotek- og dokumentasjonsvitenskap',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 366',
    Studienavn: 'Filosofi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 369',
    Studienavn: 'Økonomi og administrasjon, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ØKADM',
    ORD: 38.5,
    ORDF: 38.5,
  },
  {
    Studiekode: '186 395',
    Studienavn: 'Informatikk, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 427',
    Studienavn: 'Biomedisin',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 468',
    Studienavn: 'Økonomi og administrasjon, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'ØKADM',
    ORD: 50,
    ORDF: 0,
  },
  {
    Studiekode: '186 470',
    Studienavn: 'Ledelse, innovasjon og marked, Harstad',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 474',
    Studienavn: 'Samfunnsplanlegging og kulturforståelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 475',
    Studienavn: 'Kunsthistorie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 478',
    Studienavn: 'Arkeologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 479',
    Studienavn: 'Filosofi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 482',
    Studienavn: 'Religionsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 483',
    Studienavn: 'Russlandsstudier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 485',
    Studienavn: 'Idrettsvitenskap, Alta',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 486',
    Studienavn: 'Idrettsvitenskap, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 507',
    Studienavn: 'Idrett, Alta',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 522',
    Studienavn: 'Grunnskolelærer, 1-7.trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 530',
    Studienavn: 'Internasjonal beredskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'SAMFUNN',
    ORD: 49.3,
    ORDF: 0,
  },
  {
    Studiekode: '186 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Alta',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 554',
    Studienavn: 'Paramedisin',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 59.6,
    ORDF: 51.4,
  },
  {
    Studiekode: '186 563',
    Studienavn: 'Barnevern, Harstad',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 585',
    Studienavn: 'Informatikk, helseteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 586',
    Studienavn: 'Ingeniør, prosessteknologi, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 587',
    Studienavn: 'Ingeniør, bygg, VVS',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 605',
    Studienavn: 'Arktisk friluftsliv',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 615',
    Studienavn: 'Allmenn litteraturvitenskap',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 616',
    Studienavn: 'Russisk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 644',
    Studienavn: 'Luftfartsfag',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '186 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Alta',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 664',
    Studienavn: 'Ledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'ØKADM',
    ORD: 47.3,
    ORDF: 0,
  },
  {
    Studiekode: '186 675',
    Studienavn: 'Ingeniør, bygg, Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 677',
    Studienavn: 'Nordsamisk på begynnernivå',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 700',
    Studienavn: 'Ergoterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 701',
    Studienavn: 'Radiografi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORD: 41,
    ORDF: 41.1,
  },
  {
    Studiekode: '186 702',
    Studienavn: 'Bioingeniørfag',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 703',
    Studienavn: 'Fysioterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORD: 59.1,
    ORDF: 51.3,
  },
  {
    Studiekode: '186 708',
    Studienavn: 'Ernæring',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 709',
    Studienavn: 'Akvamedisin',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 724',
    Studienavn: 'Rettsvitenskap',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'JUS',
    ORD: 61.8,
    ORDF: 54.7,
  },
  {
    Studiekode: '186 740',
    Studienavn: 'Medisin',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 66.8,
    ORDF: 57.8,
  },
  {
    Studiekode: '186 742',
    Studienavn: 'Odontologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 61.1,
    ORDF: 55.7,
  },
  {
    Studiekode: '186 743',
    Studienavn: 'Tannpleie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 46.2,
    ORDF: 46.8,
  },
  {
    Studiekode: '186 749',
    Studienavn: 'Farmasi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - RESEPTAR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 752',
    Studienavn: 'Psykologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 769',
    Studienavn: 'Klima og miljøovervåkning',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 785',
    Studienavn: 'Informatikk, datamaskinsystemer',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 803',
    Studienavn: 'Kunstig intelligens',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 807',
    Studienavn: 'Informatikk, cybersikkerhet',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 809',
    Studienavn: 'Fornybar energi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 814',
    Studienavn: 'Romfysikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 844',
    Studienavn: 'Lektor, 8.-13. trinn, språk og samfunnsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 846',
    Studienavn: 'Medie- og dokumentasjonsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 852',
    Studienavn: 'Pedagogikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 853',
    Studienavn: 'Spesialpedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'PEDFAG',
    ORD: 36.6,
    ORDF: 0,
  },
  {
    Studiekode: '186 859',
    Studienavn: 'Geologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 860',
    Studienavn: 'Kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 862',
    Studienavn: 'Matematiske realfag',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 867',
    Studienavn: 'Ledelse, innovasjon og marked, Tromsø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 876',
    Studienavn: 'Psykologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 47.3,
    ORDF: 44.6,
  },
  {
    Studiekode: '186 877',
    Studienavn: 'Samfunnssikkerhet og miljø',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 45.2,
    ORDF: 0,
  },
  {
    Studiekode: '186 879',
    Studienavn: 'Sosialantropologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 880',
    Studienavn: 'Sosiologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 881',
    Studienavn: 'Statsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 886',
    Studienavn: 'Russisk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 887',
    Studienavn: 'Engelsk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 889',
    Studienavn: 'Nordisk språk og litteratur',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 898',
    Studienavn: 'Samfunnsøkonomi med datavitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 917',
    Studienavn: 'Ingeniør, prosessteknologi, Alta/Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 924',
    Studienavn: 'Spansk- og latinamerikanske studier',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 941',
    Studienavn: 'Psykologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 66.4,
    ORDF: 56.7,
  },
  {
    Studiekode: '186 953',
    Studienavn: 'Anvendt fysikk og matematikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '186 955',
    Studienavn: 'Sikkerhet og beredskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Sør-Varanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 49.3,
    ORDF: 0,
  },
  {
    Studiekode: '186 956',
    Studienavn: 'Ingeniør, satelitteknologi, Alta/Narvik',
    Studiekategori: 'Bachelor',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '189 030',
    Studienavn: 'Arkitekt',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'AHO',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - ARKITEKT',
    ORD: 151.8,
    ORDF: 141.8,
  },
  {
    Studiekode: '189 343',
    Studienavn: 'Design',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'AHO',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 163.8,
    ORDF: 154.1,
  },
  {
    Studiekode: '189 732',
    Studienavn: 'Landskapsarkitektur',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'AHO',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 150.5,
    ORDF: 150.6,
  },
  {
    Studiekode: '190 196',
    Studienavn: 'Teologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 242',
    Studienavn: 'Samfunnsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 474',
    Studienavn: 'Freds- og konfliktstudier',
    Studiekategori: 'Bachelor',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 480',
    Studienavn: 'Teologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 482',
    Studienavn: 'Samfunn, politikk og religion',
    Studiekategori: 'Bachelor',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 910',
    Studienavn: 'Religion',
    Studiekategori: 'Årsstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 929',
    Studienavn: 'Religionsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 930',
    Studienavn: 'Globalisering og sosial bærekraft',
    Studiekategori: 'Bachelor',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 934',
    Studienavn: 'Lektor, 8.-13. trinn, KRLE/rel. og etikk og samf.',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '190 936',
    Studienavn: 'Teologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '191 340',
    Studienavn: 'Business, economics and data science - siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NHH',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 63.2,
    ORDF: 59.6,
  },
  {
    Studiekode: '191 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NHH',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 59.6,
    ORDF: 55.2,
  },
  {
    Studiekode: '192 199',
    Studienavn: 'Ettårig grunnstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 59.3,
    ORDF: 54.5,
  },
  {
    Studiekode: '192 230',
    Studienavn: 'Eiendom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 51.9,
    ORDF: 47.5,
  },
  {
    Studiekode: '192 233',
    Studienavn: 'Frie realfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 42.8,
    ORDF: 35.3,
  },
  {
    Studiekode: '192 253',
    Studienavn: 'Bærekraftig økonomi og ledelse, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 298',
    Studienavn: 'Akvakultur',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 299',
    Studienavn: 'Bioteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 51.7,
    ORDF: 51.7,
  },
  {
    Studiekode: '192 310',
    Studienavn: 'Landskapsingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 55.2,
    ORDF: 49.4,
  },
  {
    Studiekode: '192 315',
    Studienavn: 'Radioaktivitet og miljø',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 321',
    Studienavn: 'Husdyrvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 322',
    Studienavn: 'Skogfag',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 49,
    ORDF: 40.4,
  },
  {
    Studiekode: '192 327',
    Studienavn: 'Biologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 42.8,
    ORDF: 41.9,
  },
  {
    Studiekode: '192 332',
    Studienavn: 'Kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 369',
    Studienavn: 'Økonomi og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORD: 48.6,
    ORDF: 45.8,
  },
  {
    Studiekode: '192 377',
    Studienavn: 'Miljøvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 388',
    Studienavn: 'Økologi og naturforvaltning',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 406',
    Studienavn: 'Geomatikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 468',
    Studienavn: 'Samfunnsøkonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORD: 48,
    ORDF: 44.8,
  },
  {
    Studiekode: '192 484',
    Studienavn: 'Internasjonale miljø- og utviklingsstudier',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 44.7,
    ORDF: 45.1,
  },
  {
    Studiekode: '192 504',
    Studienavn: 'Dyrepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORD: 50.4,
    ORDF: 40.5,
  },
  {
    Studiekode: '192 591',
    Studienavn: 'Økonomi, ledelse og IT',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORD: 48.5,
    ORDF: 45,
  },
  {
    Studiekode: '192 732',
    Studienavn: 'Landskapsarkitektur',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 59.2,
    ORDF: 53.5,
  },
  {
    Studiekode: '192 759',
    Studienavn: 'Byggeteknikk og arkitektur',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 52,
    ORDF: 47.7,
  },
  {
    Studiekode: '192 766',
    Studienavn: 'Teknologi og produktutvikling',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 767',
    Studienavn: 'Industriell økonomi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 57,
    ORDF: 52.7,
  },
  {
    Studiekode: '192 772',
    Studienavn: 'Veterinærmedisin',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORD: 63.6,
    ORDF: 55.7,
  },
  {
    Studiekode: '192 783',
    Studienavn: 'Kjemi og bioteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 47.3,
    ORDF: 0,
  },
  {
    Studiekode: '192 784',
    Studienavn: 'Miljøfysikk og fornybar energi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 57.5,
    ORDF: 46.7,
  },
  {
    Studiekode: '192 804',
    Studienavn: 'Datavitenskap',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 809',
    Studienavn: 'Vann- og miljøteknikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 810',
    Studienavn: 'Anvendt robotikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 813',
    Studienavn: 'Geoinformatikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 835',
    Studienavn: 'Fornybar energi',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 43.8,
    ORDF: 43.6,
  },
  {
    Studiekode: '192 842',
    Studienavn: 'Plantevitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 857',
    Studienavn: 'Energi- og miljøfysikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 948',
    Studienavn: 'Matvitenskap og ernæring',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '192 949',
    Studienavn: 'By- og regionplanlegging',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORD: 52.2,
    ORDF: 48,
  },
  {
    Studiekode: '194 003',
    Studienavn: 'Ingeniør, bygg, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 44.6,
    ORDF: 44.3,
  },
  {
    Studiekode: '194 004',
    Studienavn: 'Ingeniør, data - cybersikkerhet og programmering',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 49.3,
    ORDF: 48.2,
  },
  {
    Studiekode: '194 005',
    Studienavn: 'Ingeniør, elektro',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 43.9,
    ORDF: 45.6,
  },
  {
    Studiekode: '194 007',
    Studienavn: 'Ingeniør, flyingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 65.5,
    ORDF: 58.9,
  },
  {
    Studiekode: '194 009',
    Studienavn: 'Ingeniør, kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 52.1,
    ORDF: 51.3,
  },
  {
    Studiekode: '194 012',
    Studienavn: 'Ingeniør, maskin, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 39.6,
    ORDF: 43.9,
  },
  {
    Studiekode: '194 013',
    Studienavn: 'Ingeniør, materialteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 53,
    ORDF: 49.6,
  },
  {
    Studiekode: '194 016',
    Studienavn: 'Ingeniør, logistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 52.6,
    ORDF: 48.5,
  },
  {
    Studiekode: '194 021',
    Studienavn: 'Ingeniør, havbruk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 53,
    ORDF: 49.3,
  },
  {
    Studiekode: '194 023',
    Studienavn: 'Ingeniør, bygg, Ålesund',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 39.5,
    ORDF: 35.2,
  },
  {
    Studiekode: '194 024',
    Studienavn: 'Ingeniør, elektronisk systemingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 54.8,
    ORDF: 51.4,
  },
  {
    Studiekode: '194 025',
    Studienavn: 'Ingeniør, mekatronikk og produktdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 44.4,
    ORDF: 44.9,
  },
  {
    Studiekode: '194 033',
    Studienavn: 'Tradisjonelt bygghandverk, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 034',
    Studienavn: 'Ingeniør, maskin, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 55.7,
    ORDF: 52.3,
  },
  {
    Studiekode: '194 035',
    Studienavn: 'Økonomi og administrasjon, Trondheim, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORD: 57,
    ORDF: 52.3,
  },
  {
    Studiekode: '194 046',
    Studienavn: 'Webutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 37.4,
    ORDF: 0,
  },
  {
    Studiekode: '194 050',
    Studienavn: 'Sykepleie, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 055',
    Studienavn: 'Sykepleie, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 51.7,
    ORDF: 49.1,
  },
  {
    Studiekode: '194 056',
    Studienavn: 'Sykepleie, Ålesund',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 46.7,
    ORDF: 42.8,
  },
  {
    Studiekode: '194 067',
    Studienavn: 'Ingeniør, bygg, fleksibel, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 41.6,
    ORDF: 0,
  },
  {
    Studiekode: '194 069',
    Studienavn: 'Ingeniør, maskin, fleksibel, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 38.2,
    ORDF: 0,
  },
  {
    Studiekode: '194 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 48.5,
    ORDF: 45.9,
  },
  {
    Studiekode: '194 072',
    Studienavn: 'Ingeniør, fornybar energi, Ålesund',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 51.2,
    ORDF: 45.3,
  },
  {
    Studiekode: '194 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 52.1,
    ORDF: 49.1,
  },
  {
    Studiekode: '194 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, med norsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 085',
    Studienavn: 'Arkiv, museum og dokumentasjonsforvaltning',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 47.9,
    ORDF: 0,
  },
  {
    Studiekode: '194 090',
    Studienavn: 'Ingeniør, automatisering og intelligente systemer, Ålesund',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 49.8,
    ORDF: 48.6,
  },
  {
    Studiekode: '194 109',
    Studienavn: 'Yrkesfaglærer, bygg- og anleggsteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '194 123',
    Studienavn: 'Yrkesfaglærer, helse- og oppvekstfag',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '194 124',
    Studienavn: 'Yrkesfaglærer, restaurant- og matfag',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '194 127',
    Studienavn: 'Yrkesfaglærer, elektro og datateknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '194 129',
    Studienavn: 'Yrkesfaglærer, teknologi og industrifag',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '194 136',
    Studienavn: 'Medievitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 43.7,
    ORDF: 40.4,
  },
  {
    Studiekode: '194 149',
    Studienavn: 'Grafisk design',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 47.6,
    ORDF: 43.2,
  },
  {
    Studiekode: '194 160',
    Studienavn: 'Økonomi og administrasjon, Gjøvik, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORD: 45.4,
    ORDF: 35.7,
  },
  {
    Studiekode: '194 170',
    Studienavn: 'Engelsk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 47.5,
    ORDF: 0,
  },
  {
    Studiekode: '194 174',
    Studienavn: 'Fransk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 184',
    Studienavn: 'Biologi og kjemi, realfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 56.2,
    ORDF: 53.9,
  },
  {
    Studiekode: '194 186',
    Studienavn: 'Medisinske og biologiske fag',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 200',
    Studienavn: 'Kunsthistorie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 205',
    Studienavn: 'Matematiske fag, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 49,
    ORDF: 41,
  },
  {
    Studiekode: '194 210',
    Studienavn: 'Nordisk språk og litteratur',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 218',
    Studienavn: 'Økonomi og administrasjon, Trondheim, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORD: 63.2,
    ORDF: 52.3,
  },
  {
    Studiekode: '194 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'PEDFAG',
    ORD: 50,
    ORDF: 40.4,
  },
  {
    Studiekode: '194 221',
    Studienavn: 'Tegnspråk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 52.7,
    ORDF: 0,
  },
  {
    Studiekode: '194 222',
    Studienavn: 'Likestilling og mangfold',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 52.8,
    ORDF: 47.9,
  },
  {
    Studiekode: '194 239',
    Studienavn: 'Samfunnsøkonomi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORD: 55.7,
    ORDF: 48.8,
  },
  {
    Studiekode: '194 240',
    Studienavn: 'Sosiologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 51.3,
    ORDF: 46.2,
  },
  {
    Studiekode: '194 242',
    Studienavn: 'Studier av kunnskap, teknologi og samfunn (STS)',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 49.1,
    ORDF: 0,
  },
  {
    Studiekode: '194 244',
    Studienavn: 'Tysk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 262',
    Studienavn: 'Filmvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 46,
    ORDF: 41.6,
  },
  {
    Studiekode: '194 264',
    Studienavn: 'Interaksjonsdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 45.8,
    ORDF: 37.4,
  },
  {
    Studiekode: '194 272',
    Studienavn: 'Kunsthistorie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 284',
    Studienavn: 'Geografi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 50.9,
    ORDF: 34.5,
  },
  {
    Studiekode: '194 287',
    Studienavn: 'Informasjonsbehandling',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORD: 61.5,
    ORDF: 0,
  },
  {
    Studiekode: '194 294',
    Studienavn: 'Latin',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 298',
    Studienavn: 'Biomarin innovasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'REALFAG',
    ORD: 48,
    ORDF: 46.8,
  },
  {
    Studiekode: '194 299',
    Studienavn: 'Bioingeniør, Ålesund',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 41.2,
    ORDF: 41.3,
  },
  {
    Studiekode: '194 300',
    Studienavn: 'Digital infrastruktur og cybersikkerhet, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'INFOTEKN',
    ORD: 50.5,
    ORDF: 43.5,
  },
  {
    Studiekode: '194 324',
    Studienavn: 'Samfunnsvitenskapelige fag, emnestudier',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 52.7,
    ORDF: 0,
  },
  {
    Studiekode: '194 327',
    Studienavn: 'Biologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 53.7,
    ORDF: 51.5,
  },
  {
    Studiekode: '194 345',
    Studienavn: 'Økonomi og administrasjon, siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORD: 60.4,
    ORDF: 53.9,
  },
  {
    Studiekode: '194 346',
    Studienavn: 'Matvitenskap, teknologi og bærekraft',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 49.4,
    ORDF: 48.5,
  },
  {
    Studiekode: '194 353',
    Studienavn: 'Nautikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORD: 52.1,
    ORDF: 44.6,
  },
  {
    Studiekode: '194 359',
    Studienavn: 'Markedsføring, innovasjon og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'ØKADM',
    ORD: 42.6,
    ORDF: 42.9,
  },
  {
    Studiekode: '194 366',
    Studienavn: 'Filosofi',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 42.5,
    ORDF: 0,
  },
  {
    Studiekode: '194 367',
    Studienavn: 'Sosialantropologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 48.6,
    ORDF: 44.9,
  },
  {
    Studiekode: '194 369',
    Studienavn: 'Økonomi og administrasjon, Gjøvik, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORD: 44,
    ORDF: 43.2,
  },
  {
    Studiekode: '194 395',
    Studienavn: 'Informatikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.4,
    ORDF: 51.4,
  },
  {
    Studiekode: '194 400',
    Studienavn: 'Etikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 404',
    Studienavn: 'Økonomi og administrasjon, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORD: 54.3,
    ORDF: 0,
  },
  {
    Studiekode: '194 414',
    Studienavn: 'Økonomi og administrasjon, Ålesund, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'ØKADM',
    ORD: 45.1,
    ORDF: 44.5,
  },
  {
    Studiekode: '194 422',
    Studienavn: 'Digital forretningsutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORD: 58.5,
    ORDF: 52.2,
  },
  {
    Studiekode: '194 427',
    Studienavn: 'Bioteknologi, Ålesund',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 432',
    Studienavn: 'Logistikkledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORD: 42.7,
    ORDF: 34.6,
  },
  {
    Studiekode: '194 437',
    Studienavn: 'Musikkvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 438',
    Studienavn: 'Geografi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 38.2,
    ORDF: 40,
  },
  {
    Studiekode: '194 439',
    Studienavn: 'Drama og teater, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 440',
    Studienavn: 'Bevegelsesvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'IDRETT',
    ORD: 48.8,
    ORDF: 45.3,
  },
  {
    Studiekode: '194 456',
    Studienavn: 'Allmenn litteraturvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 459',
    Studienavn: 'Antikkens kultur og klassiske fag',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 466',
    Studienavn: 'Norsk tegnspråk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 470',
    Studienavn: 'Shipping management',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORD: 51.7,
    ORDF: 48.5,
  },
  {
    Studiekode: '194 474',
    Studienavn: 'Europastudier med statsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 52,
    ORDF: 51.3,
  },
  {
    Studiekode: '194 476',
    Studienavn: 'Musikkteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 51.2,
    ORDF: 46.1,
  },
  {
    Studiekode: '194 478',
    Studienavn: 'Arkeologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 479',
    Studienavn: 'Filosofi og etikk - filosofi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 486',
    Studienavn: 'Samfunns- og idrettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'IDRETT',
    ORD: 45.9,
    ORDF: 44.2,
  },
  {
    Studiekode: '194 497',
    Studienavn: 'Medisin, Trondheim/Gjøvik',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 67.3,
    ORDF: 58.7,
  },
  {
    Studiekode: '194 498',
    Studienavn: 'Medisin, Trondheim/Levanger',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NTNU',
    Studiested: 'Levanger',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 67.5,
    ORDF: 59.3,
  },
  {
    Studiekode: '194 499',
    Studienavn: 'Medisin, Trondheim/Ålesund',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 68.2,
    ORDF: 59.8,
  },
  {
    Studiekode: '194 503',
    Studienavn: 'Ingeniør, data - systemutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 56.6,
    ORDF: 53.6,
  },
  {
    Studiekode: '194 508',
    Studienavn: 'Bevegelsesvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'IDRETT',
    ORD: 54.2,
    ORDF: 48.5,
  },
  {
    Studiekode: '194 531',
    Studienavn: 'Radiografi, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORD: 52.8,
    ORDF: 48.3,
  },
  {
    Studiekode: '194 554',
    Studienavn: 'Paramedisin',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 52.5,
    ORDF: 46.8,
  },
  {
    Studiekode: '194 588',
    Studienavn: 'Filosofi og etikk - etikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 594',
    Studienavn: 'Ergoterapi, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORD: 42.9,
    ORDF: 41.9,
  },
  {
    Studiekode: '194 597',
    Studienavn: 'Lektor i kroppsøving og idrettsfag, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 54.5,
    ORDF: 52.2,
  },
  {
    Studiekode: '194 602',
    Studienavn: 'Produktdesign og teknologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 45.9,
    ORDF: 0,
  },
  {
    Studiekode: '194 604',
    Studienavn: 'Webdesign',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 615',
    Studienavn: 'Allmenn litteraturvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 616',
    Studienavn: 'Fransk med didaktikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 646',
    Studienavn: 'Film- og videoproduksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 58.9,
    ORDF: 52.9,
  },
  {
    Studiekode: '194 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, med matematikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 673',
    Studienavn: 'Programmering',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'INFOTEKN',
    ORD: 48.9,
    ORDF: 38.4,
  },
  {
    Studiekode: '194 675',
    Studienavn: 'Ingeniør, bygg, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 55.5,
    ORDF: 51.3,
  },
  {
    Studiekode: '194 684',
    Studienavn: 'Lektor i historie, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 51.8,
    ORDF: 49.2,
  },
  {
    Studiekode: '194 685',
    Studienavn: 'Lektor i språkfag/engelsk, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 686',
    Studienavn: 'Lektor i språkfag/fransk, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 687',
    Studienavn: 'Lektor i språkfag/nordisk, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 689',
    Studienavn: 'Lektor i språkfag/tysk, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 699',
    Studienavn: 'Ingeniør, skipsingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 44.2,
    ORDF: 47.7,
  },
  {
    Studiekode: '194 700',
    Studienavn: 'Ergoterapi, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '194 701',
    Studienavn: 'Radiografi, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORD: 48,
    ORDF: 41.1,
  },
  {
    Studiekode: '194 702',
    Studienavn: 'Bioingeniør, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 54.6,
    ORDF: 52.5,
  },
  {
    Studiekode: '194 703',
    Studienavn: 'Fysioterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORD: 57.8,
    ORDF: 52.9,
  },
  {
    Studiekode: '194 704',
    Studienavn: 'Audiologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - AUDIO',
    ORD: 44.4,
    ORDF: 36,
  },
  {
    Studiekode: '194 715',
    Studienavn: 'Humanistiske fag,  emnestudier',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 740',
    Studienavn: 'Medisin, Trondheim',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORD: 69.4,
    ORDF: 61.7,
  },
  {
    Studiekode: '194 752',
    Studienavn: 'Psykologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 54.6,
    ORDF: 49.4,
  },
  {
    Studiekode: '194 755',
    Studienavn: 'Materialteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 53.7,
    ORDF: 52.8,
  },
  {
    Studiekode: '194 756',
    Studienavn: 'Arkitektur',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - ARKITEKT',
    ORD: 60.5,
    ORDF: 55.2,
  },
  {
    Studiekode: '194 759',
    Studienavn: 'Bygg- og miljøteknikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 55.3,
    ORDF: 52.2,
  },
  {
    Studiekode: '194 760',
    Studienavn: 'Datateknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 63.8,
    ORDF: 58.7,
  },
  {
    Studiekode: '194 761',
    Studienavn: 'Elektronisk systemdesign og innovasjon',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 56.9,
    ORDF: 55.4,
  },
  {
    Studiekode: '194 762',
    Studienavn: 'Maskin- og energiteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 58.9,
    ORDF: 56.3,
  },
  {
    Studiekode: '194 763',
    Studienavn: 'Fysikk og matematikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 59.5,
    ORDF: 58.6,
  },
  {
    Studiekode: '194 764',
    Studienavn: 'Industriell kjemi og bioteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 52.7,
    ORDF: 54.4,
  },
  {
    Studiekode: '194 765',
    Studienavn: 'Marin teknikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 57.9,
    ORDF: 55.5,
  },
  {
    Studiekode: '194 767',
    Studienavn: 'Industriell økonomi og teknologiledelse',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 68,
    ORDF: 62.1,
  },
  {
    Studiekode: '194 768',
    Studienavn: 'Industriell design',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 61.7,
    ORDF: 57.2,
  },
  {
    Studiekode: '194 769',
    Studienavn: 'Energi og miljø',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 56,
    ORDF: 54.3,
  },
  {
    Studiekode: '194 770',
    Studienavn: 'Cybersikkerhet og datakommunikasjon',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 60.2,
    ORDF: 56.5,
  },
  {
    Studiekode: '194 777',
    Studienavn: 'Musikkvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 786',
    Studienavn: 'Europastudier med spansk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 793',
    Studienavn: 'Europastudier med fransk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 795',
    Studienavn: 'Europastudier med tysk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 796',
    Studienavn: 'Drama og teater, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORD: 45.9,
    ORDF: 38.9,
  },
  {
    Studiekode: '194 798',
    Studienavn: 'Kybernetikk og robotikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 63,
    ORDF: 59.2,
  },
  {
    Studiekode: '194 809',
    Studienavn: 'Georessurser og geoteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 56,
    ORDF: 55.7,
  },
  {
    Studiekode: '194 818',
    Studienavn: 'Samfunnsøkonomi, master',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORD: 55,
    ORDF: 51.2,
  },
  {
    Studiekode: '194 819',
    Studienavn: 'Ingeniørgeologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 56.9,
    ORDF: 54,
  },
  {
    Studiekode: '194 822',
    Studienavn: 'Ingeniør, fornybar energi, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 55,
    ORDF: 52.6,
  },
  {
    Studiekode: '194 823',
    Studienavn: 'Ingeniør, automatisering og intelligente systemer, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 57.4,
    ORDF: 53.9,
  },
  {
    Studiekode: '194 824',
    Studienavn: 'Produktdesign og teknologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 43,
    ORDF: 39.5,
  },
  {
    Studiekode: '194 835',
    Studienavn: 'Ingeniør, fornybar energi, Gjøvik',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 840',
    Studienavn: 'Ingeniør, data - applikasjonsutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 843',
    Studienavn: 'Lektor i realfag, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 44.3,
    ORDF: 48.8,
  },
  {
    Studiekode: '194 847',
    Studienavn: 'Filmvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 28.7,
    ORDF: 33.2,
  },
  {
    Studiekode: '194 851',
    Studienavn: 'Medievitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 45.8,
    ORDF: 44.8,
  },
  {
    Studiekode: '194 852',
    Studienavn: 'Pedagogikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'PEDFAG',
    ORD: 43.5,
    ORDF: 39.3,
  },
  {
    Studiekode: '194 855',
    Studienavn: 'Bioteknologi, Trondheim',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 60.5,
    ORDF: 57,
  },
  {
    Studiekode: '194 857',
    Studienavn: 'Fysikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 52.7,
    ORDF: 53.1,
  },
  {
    Studiekode: '194 859',
    Studienavn: 'Geologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 57.5,
    ORDF: 52.2,
  },
  {
    Studiekode: '194 860',
    Studienavn: 'Kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 47.9,
    ORDF: 50.2,
  },
  {
    Studiekode: '194 862',
    Studienavn: 'Matematiske fag, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORD: 50.5,
    ORDF: 49,
  },
  {
    Studiekode: '194 870',
    Studienavn: 'Europastudier med engelsk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 42,
    ORDF: 43.2,
  },
  {
    Studiekode: '194 876',
    Studienavn: 'Psykologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 55.5,
    ORDF: 51.1,
  },
  {
    Studiekode: '194 879',
    Studienavn: 'Sosialantropologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 35.2,
    ORDF: 37.5,
  },
  {
    Studiekode: '194 880',
    Studienavn: 'Sosiologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 46.4,
    ORDF: 45,
  },
  {
    Studiekode: '194 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 52,
    ORDF: 50.1,
  },
  {
    Studiekode: '194 887',
    Studienavn: 'Engelsk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 888',
    Studienavn: 'Fransk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 889',
    Studienavn: 'Nordisk språk, litteratur og norsk som andrespråk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 890',
    Studienavn: 'Tysk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 898',
    Studienavn: 'Samfunnsøkonomi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORD: 56.5,
    ORDF: 50,
  },
  {
    Studiekode: '194 904',
    Studienavn: 'Kulturminneforvaltning',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 905',
    Studienavn: 'Ingeniørvitenskap og IKT',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 59,
    ORDF: 55.3,
  },
  {
    Studiekode: '194 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 912',
    Studienavn: 'Spansk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 924',
    Studienavn: 'Spansk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 929',
    Studienavn: 'Religionsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 934',
    Studienavn: 'Lektor i geografi, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 937',
    Studienavn: 'Nanoteknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 60.2,
    ORDF: 59.7,
  },
  {
    Studiekode: '194 940',
    Studienavn: 'Digital infrastruktur og cybersikkerhet, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORD: 57.2,
    ORDF: 51.4,
  },
  {
    Studiekode: '194 941',
    Studienavn: 'Psykologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORD: 66.5,
    ORDF: 58.3,
  },
  {
    Studiekode: '194 945',
    Studienavn: 'Lektor i samfunnsfag, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 52.5,
    ORDF: 50.4,
  },
  {
    Studiekode: '194 947',
    Studienavn: 'Ingeniør, geomatikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '194 956',
    Studienavn: 'Ingeniør, elektrifisering og digitalisering',
    Studiekategori: 'Bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 54,
    ORDF: 50.2,
  },
  {
    Studiekode: '201 003',
    Studienavn: 'Ingeniør, byggdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 004',
    Studienavn: 'Ingeniør, data',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 006',
    Studienavn: 'Ingeniør, fornybar energi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 012',
    Studienavn: 'Ingeniør, mekatronikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 050',
    Studienavn: 'Sykepleie, Kristiansand',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 47,
    ORDF: 45.9,
  },
  {
    Studiekode: '201 052',
    Studienavn: 'Sykepleie, Grimstad',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 48.6,
    ORDF: 41.9,
  },
  {
    Studiekode: '201 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 47.2,
    ORDF: 43.2,
  },
  {
    Studiekode: '201 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 51.6,
    ORDF: 47.9,
  },
  {
    Studiekode: '201 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 130',
    Studienavn: 'Barnehagelærer, Kristiansand',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 132',
    Studienavn: 'Barnehagelærer, Grimstad',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 149',
    Studienavn: 'Multimedieteknologi og -design',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 170',
    Studienavn: 'Engelsk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 172',
    Studienavn: 'Friluftsliv',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 174',
    Studienavn: 'Fransk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 184',
    Studienavn: 'Biologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 187',
    Studienavn: 'IKT',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 189',
    Studienavn: 'IT og informasjonssystemer, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'INFOTEKN',
    ORD: 49.2,
    ORDF: 27.5,
  },
  {
    Studiekode: '201 200',
    Studienavn: 'Visuell kunst og formidling, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 203',
    Studienavn: 'Folkehelsearbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 47,
    ORDF: 33,
  },
  {
    Studiekode: '201 205',
    Studienavn: 'Matematikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 210',
    Studienavn: 'Nordisk språk og litteratur, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 39,
    ORDF: 35.7,
  },
  {
    Studiekode: '201 240',
    Studienavn: 'Sosiologi',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 43.5,
    ORDF: 41.3,
  },
  {
    Studiekode: '201 247',
    Studienavn: 'Globale utviklingsstudier, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 40,
    ORDF: 41.8,
  },
  {
    Studiekode: '201 260',
    Studienavn: 'IT og informasjonssystemer, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'INFOTEKN',
    ORD: 47.3,
    ORDF: 40,
  },
  {
    Studiekode: '201 327',
    Studienavn: 'Biologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 336',
    Studienavn: 'Skolebibliotekkunnskap, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 45.7,
    ORDF: 0,
  },
  {
    Studiekode: '201 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORD: 46,
    ORDF: 44.8,
  },
  {
    Studiekode: '201 359',
    Studienavn: 'Markedsføring og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORD: 47.2,
    ORDF: 45.5,
  },
  {
    Studiekode: '201 366',
    Studienavn: 'Filosofi',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 369',
    Studienavn: 'Økonomi og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORD: 50,
    ORDF: 47.8,
  },
  {
    Studiekode: '201 373',
    Studienavn: 'Biologi, årsstudium, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 48.6,
    ORDF: 0,
  },
  {
    Studiekode: '201 440',
    Studienavn: 'Idrett, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'IDRETT',
    ORD: 36.1,
    ORDF: 36.4,
  },
  {
    Studiekode: '201 456',
    Studienavn: 'Film, litteratur og teater',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 41.4,
    ORDF: 39.6,
  },
  {
    Studiekode: '201 474',
    Studienavn: 'Samfunnsplanlegging og kommunikasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 37.1,
    ORDF: 36.7,
  },
  {
    Studiekode: '201 479',
    Studienavn: 'Anvendt filosofi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 482',
    Studienavn: 'Religion, etikk og samfunn, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 484',
    Studienavn: 'Globale utviklingsstudier, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 42.3,
    ORDF: 39.6,
  },
  {
    Studiekode: '201 489',
    Studienavn: 'Akademisk e-sport',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'INFOTEKN',
    ORD: 45.9,
    ORDF: 35.8,
  },
  {
    Studiekode: '201 526',
    Studienavn: 'Rettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'JUS',
    ORD: 59,
    ORDF: 53.7,
  },
  {
    Studiekode: '201 597',
    Studienavn: 'Lektor, 8.-13. trinn, m/idrett i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 50,
    ORDF: 50.6,
  },
  {
    Studiekode: '201 618',
    Studienavn: 'Teater og drama',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 642',
    Studienavn: 'Visuell kunst og formidling, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 646',
    Studienavn: 'Samfunnsrettet ernæring',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 36.8,
    ORDF: 0,
  },
  {
    Studiekode: '201 649',
    Studienavn: 'Idrett, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'IDRETT',
    ORD: 39.4,
    ORDF: 40.1,
  },
  {
    Studiekode: '201 652',
    Studienavn: 'Religion, etikk og samfunn, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 661',
    Studienavn: 'Fysikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 663',
    Studienavn: 'Kommunikasjon, medieproduksjon, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 47,
    ORDF: 28.9,
  },
  {
    Studiekode: '201 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 670',
    Studienavn: 'Naturfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 676',
    Studienavn: 'Pedagogikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'PEDFAG',
    ORD: 53,
    ORDF: 39.6,
  },
  {
    Studiekode: '201 684',
    Studienavn: 'Lektor, 8.-13. trinn, m/historie i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 49.6,
    ORDF: 50,
  },
  {
    Studiekode: '201 685',
    Studienavn: 'Lektor, 8.-13. trinn, m/engelsk i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 43,
    ORDF: 46.4,
  },
  {
    Studiekode: '201 687',
    Studienavn: 'Lektor, 8.-13. trinn, m/norsk i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 690',
    Studienavn: 'Tysk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 697',
    Studienavn: 'Lektor, 8-13 trinn, m/matematikk i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 702',
    Studienavn: 'Bioingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 50.3,
    ORDF: 47.1,
  },
  {
    Studiekode: '201 767',
    Studienavn: 'Industriell økonomi og teknologiledelse',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 42.4,
    ORDF: 0,
  },
  {
    Studiekode: '201 794',
    Studienavn: 'Kommunikasjon, kommunikasjon og medier, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 796',
    Studienavn: 'Samtidsteater',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 803',
    Studienavn: 'Ingeniør, elektronikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 807',
    Studienavn: 'Kunstig intelligens',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 843',
    Studienavn: 'Lektor, 8-13 trinn, m/naturfag i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 850',
    Studienavn: 'Kommunikasjon, kommunikasjon og medier, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 35,
    ORDF: 37.1,
  },
  {
    Studiekode: '201 851',
    Studienavn: 'Kommunikasjon, medieproduksjon, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 45,
    ORDF: 44,
  },
  {
    Studiekode: '201 852',
    Studienavn: 'Pedagogikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'PEDFAG',
    ORD: 42.4,
    ORDF: 35,
  },
  {
    Studiekode: '201 853',
    Studienavn: 'Spesialpedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'PEDFAG',
    ORD: 50,
    ORDF: 40.9,
  },
  {
    Studiekode: '201 862',
    Studienavn: 'Industriell matematikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 864',
    Studienavn: 'Samfunnsrettet ernæringsarbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 42.8,
    ORDF: 43.8,
  },
  {
    Studiekode: '201 887',
    Studienavn: 'Engelsk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 889',
    Studienavn: 'Nordisk språk og litteratur, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 900',
    Studienavn: 'Sosiologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 40.5,
    ORDF: 40,
  },
  {
    Studiekode: '201 912',
    Studienavn: 'Spansk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 934',
    Studienavn: 'Lektor, 8.-13. trinn, m/religion i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 935',
    Studienavn: 'Lektor, 8-13 trinn,m/fremmedspr. i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '201 945',
    Studienavn: 'Lektor, 8-13, m/samf. kunnsk. i første studieår',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 48.3,
    ORDF: 49.7,
  },
  {
    Studiekode: '203 002',
    Studienavn: 'Ingeniør, brannsikkerhet',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 003',
    Studienavn: 'Ingeniør, bygg, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 004',
    Studienavn: 'Ingeniør, data',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 009',
    Studienavn: 'Ingeniør, kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 011',
    Studienavn: 'Ingeniør, marinteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 012',
    Studienavn: 'Ingeniør, maskin, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 48.5,
    ORDF: 43.9,
  },
  {
    Studiekode: '203 034',
    Studienavn: 'Ingeniør, maskin, Haugesund',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 045',
    Studienavn: 'Ingeniør, bærekraftig produksjon og sirkulærøkonom',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 048',
    Studienavn: 'Ingeniør, elektroteknologi, Haugesund',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 049',
    Studienavn: 'Nautikk med integrert praksis',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORD: 46.5,
    ORDF: 42.2,
  },
  {
    Studiekode: '203 050',
    Studienavn: 'Sykepleie, Bergen, høst',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 51.2,
    ORDF: 48.1,
  },
  {
    Studiekode: '203 051',
    Studienavn: 'Sykepleie, deltid, Førde',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 052',
    Studienavn: 'Sykepleie, Førde, vår',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '203 053',
    Studienavn: 'Sykepleie, Stord, høst',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 054',
    Studienavn: 'Sykepleie, Førde, høst',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 056',
    Studienavn: 'Sykepleie, Haugesund, høst',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 059',
    Studienavn: 'Sykepleie, deltid, Stord',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 060',
    Studienavn: 'Vernepleie, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 50,
    ORDF: 44.2,
  },
  {
    Studiekode: '203 061',
    Studienavn: 'Vernepleie, deltid, Sogndal',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 47.1,
    ORDF: 0,
  },
  {
    Studiekode: '203 062',
    Studienavn: 'Vernepleie, Sogndal',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 43.3,
    ORDF: 34.6,
  },
  {
    Studiekode: '203 063',
    Studienavn: 'Vernepleie, deltid, Haugesund',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 49.9,
    ORDF: 0,
  },
  {
    Studiekode: '203 068',
    Studienavn: 'Ingeniør, elektroteknologi, Førde',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 080',
    Studienavn: 'Sosialt arbeid, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 54.2,
    ORDF: 49.4,
  },
  {
    Studiekode: '203 081',
    Studienavn: 'Sosialt arbeid, Sogndal',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 38.5,
    ORDF: 36.8,
  },
  {
    Studiekode: '203 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Stord',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Stord',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 096',
    Studienavn: 'Ingeniør, havteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 42,
    ORDF: 44,
  },
  {
    Studiekode: '203 130',
    Studienavn: 'Barnehagelærer, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 134',
    Studienavn: 'Barnehagelærer, deltid, Sogndal',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 135',
    Studienavn: 'Barnehagelærer, Stord',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 162',
    Studienavn: 'Administrasjon og ledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'ØKADM',
    ORD: 37.6,
    ORDF: 0,
  },
  {
    Studiekode: '203 170',
    Studienavn: 'Engelsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 185',
    Studienavn: 'Idrett og trening',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 203',
    Studienavn: 'Folkehelsearbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: 48.6,
    ORDF: 43.3,
  },
  {
    Studiekode: '203 218',
    Studienavn: 'Digital økonomi og ledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 55.5,
    ORDF: 47.2,
  },
  {
    Studiekode: '203 242',
    Studienavn: 'Samfunnsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORD: 55.5,
    ORDF: 0,
  },
  {
    Studiekode: '203 246',
    Studienavn: 'Jus',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'JUS',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 302',
    Studienavn: 'Friluftsliv',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 310',
    Studienavn: 'Landskapsplanlegging med landskapsarkitektur',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 317',
    Studienavn: 'Natur- og opplevelsesbasert reiseliv',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REISELIV',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '203 330',
    Studienavn: 'Reiselivsledelse, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REISELIV',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 351',
    Studienavn: 'Sosiologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORD: 57,
    ORDF: 0,
  },
  {
    Studiekode: '203 368',
    Studienavn: 'Eiendomsmegling',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 369',
    Studienavn: 'Økonomi og administrasjon, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 54.3,
    ORDF: 50.9,
  },
  {
    Studiekode: '203 395',
    Studienavn: 'Informasjonsteknologi, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORD: 50,
    ORDF: 41.3,
  },
  {
    Studiekode: '203 404',
    Studienavn: 'Økonomi og administrasjon, Haugesund',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 414',
    Studienavn: 'Økonomi og administrasjon, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'ØKADM',
    ORD: 35.4,
    ORDF: 0,
  },
  {
    Studiekode: '203 436',
    Studienavn: 'Informasjonsteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 439',
    Studienavn: 'Drama og anvendt teater',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 445',
    Studienavn: 'Barnehagelærer, Sogndal',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '203 466',
    Studienavn: 'Tegnspråk og tolking',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 469',
    Studienavn: 'Geologi og geofare',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 485',
    Studienavn: 'Idrett, trening, helse',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 505',
    Studienavn: 'Kunst og håndverk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 509',
    Studienavn: 'Personlig trener',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 513',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 515',
    Studienavn: 'Økonomi og administrasjon, Sogndal',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 526',
    Studienavn: 'Økonomi og jus',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'JUS',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 529',
    Studienavn: 'Barnehagelærer, deltid, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, kroppsøving',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 42.9,
    ORDF: 44.5,
  },
  {
    Studiekode: '203 548',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, musikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 550',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, samfunnsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 551',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, engelsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 557',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, naturfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 559',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, KRLE',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 560',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, kunst og håndverk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 564',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, kunst og håndverk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og idrettsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 46,
    ORDF: 45.7,
  },
  {
    Studiekode: '203 567',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, engelsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 569',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, KRLE',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 590',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Sogndal',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 599',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, mat og helse',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 613',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HISTORIE',
    ORD: 47.5,
    ORDF: 0,
  },
  {
    Studiekode: '203 649',
    Studienavn: 'Kroppsøving og idrettsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'IDRETT',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '203 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Sogndal',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 655',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, matematikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 657',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, samfunnsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 658',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, norsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 659',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, mat og helse',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, musikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 665',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Stord, samlingsbasert',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '203 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 675',
    Studienavn: 'Ingeniør, bygg, Førde',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '203 700',
    Studienavn: 'Ergoterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORD: 47.6,
    ORDF: 41.8,
  },
  {
    Studiekode: '203 701',
    Studienavn: 'Radiografi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORD: 50.5,
    ORDF: 44.8,
  },
  {
    Studiekode: '203 702',
    Studienavn: 'Bioingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 53,
    ORDF: 46.8,
  },
  {
    Studiekode: '203 703',
    Studienavn: 'Fysioterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORD: 56,
    ORDF: 50.4,
  },
  {
    Studiekode: '203 753',
    Studienavn: 'Landmåling og eiendomsdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 45,
    ORDF: 39.5,
  },
  {
    Studiekode: '203 754',
    Studienavn: 'Reiselivsledelse, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REISELIV',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 822',
    Studienavn: 'Ingeniør, energiteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 829',
    Studienavn: 'Informasjonsteknologi, Førde',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 835',
    Studienavn: 'Fornybar energi',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '203 927',
    Studienavn: 'Sosiologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORD: 49,
    ORDF: 0,
  },
  {
    Studiekode: '203 956',
    Studienavn: 'Ingeniør, elektroteknologi, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 050',
    Studienavn: 'Sykepleie, Bodø',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 055',
    Studienavn: 'Sykepleie, Mo i Rana',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 056',
    Studienavn: 'Sykepleie, Levanger',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 46.2,
    ORDF: 42.2,
  },
  {
    Studiekode: '204 058',
    Studienavn: 'Sykepleie, Namsos',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 39.1,
    ORDF: 0,
  },
  {
    Studiekode: '204 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 37.2,
    ORDF: 34.3,
  },
  {
    Studiekode: '204 080',
    Studienavn: 'Sosialt arbeid, Bodø',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 40.9,
    ORDF: 33,
  },
  {
    Studiekode: '204 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Bodø',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Bodø',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 089',
    Studienavn: 'Film- og TV-produksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 105',
    Studienavn: 'Yrkesfaglærer i salg, service og reiseliv',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 109',
    Studienavn: 'Yrkesfaglærer, bygg- og anleggsteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 123',
    Studienavn: 'Yrkesfaglærer, helse- og oppvekstfag',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 124',
    Studienavn: 'Yrkesfaglærer, restaurant- og matfag',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 127',
    Studienavn: 'Yrkesfaglærer i elektro- og datateknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 129',
    Studienavn: 'Yrkesfaglærer i teknologi- og industrifag',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 131',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 132',
    Studienavn: 'Barnehagelærer, deltid, Nesna',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Nesna',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 135',
    Studienavn: 'Barnehagelærer, deltid, Bodø',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 162',
    Studienavn: 'Personalledelse og kompetanseutvikling, Bodø',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 43.9,
    ORDF: 0,
  },
  {
    Studiekode: '204 164',
    Studienavn: 'Økonomi og administrasjon, Bodø, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 170',
    Studienavn: 'Engelsk, Bodø',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 172',
    Studienavn: 'Naturforvaltning, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 179',
    Studienavn: 'Historie',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 184',
    Studienavn: 'Biologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: -1,
  },
  {
    Studiekode: '204 185',
    Studienavn: 'Personlig trener',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 209',
    Studienavn: 'Økonomi, markedsføring og ledelse, deltid, Stjørdal',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Stjørdal',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 211',
    Studienavn: 'Nordområdestudier',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 218',
    Studienavn: 'Økonomi, markedsføring og ledelse, deltid, Bodø',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 231',
    Studienavn: 'Yrkesfaglærer, informasjonsteknologi og medieprod.',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 232',
    Studienavn: 'Personalledelse og kompetanseutvikling, Vesterålen',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Vesterålen',
    Utdanningsområde: 'ØKADM',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '204 240',
    Studienavn: 'Sosiologi, Levanger',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 249',
    Studienavn: 'Sosiologi, Bodø',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '204 321',
    Studienavn: 'Husdyrvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 327',
    Studienavn: 'Biologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 342',
    Studienavn: 'Økonomi og administrasjon, Bodø, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 43.2,
    ORDF: 36.9,
  },
  {
    Studiekode: '204 368',
    Studienavn: 'Eiendomsmegling og markedsanalyser',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 37.9,
    ORDF: 39.2,
  },
  {
    Studiekode: '204 388',
    Studienavn: 'Naturforvaltning, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 396',
    Studienavn: 'Geografi',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 398',
    Studienavn: 'Økonomi og digitalisering',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 404',
    Studienavn: 'Økonomi og administrasjon, Steinkjer, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 420',
    Studienavn: 'Natur- og kulturminneoppsyn',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 421',
    Studienavn: 'Husdyrvelferd',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 427',
    Studienavn: 'Animal Science',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 430',
    Studienavn: 'CG Art og animsjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 438',
    Studienavn: 'Geografi og samfunnsplanlegging',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 445',
    Studienavn: 'Barnehagelærer, deltid, Kolvereid',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Nærøysund',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 453',
    Studienavn: 'Økonomi, digitalisering og forretningsutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 454',
    Studienavn: 'Journalistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 473',
    Studienavn: 'Markedsføring',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 486',
    Studienavn: 'Idrett',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 488',
    Studienavn: 'Idrettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 504',
    Studienavn: 'Dyrepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORD: 43.1,
    ORDF: 36.2,
  },
  {
    Studiekode: '204 527',
    Studienavn: 'Luftfartsledelse, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 529',
    Studienavn: 'Barnehagelærer, deltid, Levanger',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 551',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Levanger',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 554',
    Studienavn: 'Paramedisin, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 54,
    ORDF: 40,
  },
  {
    Studiekode: '204 557',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Nesna',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Nesna',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 575',
    Studienavn: 'Lærer i praktiske og estetiske fag, 1.-13., musikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 576',
    Studienavn: 'Sosialt arbeid, Levanger',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 42.2,
    ORDF: 37.8,
  },
  {
    Studiekode: '204 581',
    Studienavn: 'Yrkesfaglærer, naturbruk',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '204 583',
    Studienavn: 'Personalledelse og kompetanseutvikling, Levanger',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ØKADM',
    ORD: 46.3,
    ORDF: 0,
  },
  {
    Studiekode: '204 591',
    Studienavn: 'Human Resource Management (HRM), Levanger',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 43.9,
    ORDF: 37,
  },
  {
    Studiekode: '204 597',
    Studienavn: 'Lektor, 8.-13. trinn, kroppsøving og idrettsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 613',
    Studienavn: 'Historie, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 623',
    Studienavn: 'Engelsk, Levanger',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 625',
    Studienavn: 'Økonomi og administrasjon, Steinkjer, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 657',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Levanger',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 659',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Nesna',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Nesna',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 673',
    Studienavn: 'Spill- og opplevelsesteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 680',
    Studienavn: 'Samfunnsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 696',
    Studienavn: 'Trafikklærer',
    Studiekategori: 'Kandidatstudium',
    Lærested: 'NORD',
    Studiested: 'Stjørdal',
    Utdanningsområde: 'LÆRER - ANNET',
    ORD: 43.4,
    ORDF: '',
  },
  {
    Studiekode: '204 717',
    Studienavn: 'Internasjonale relasjoner, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 738',
    Studienavn: 'Bærekraftig økonomi og bioproduksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '204 749',
    Studienavn: 'Farmasi',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - RESEPTAR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 867',
    Studienavn: 'Havbruksdrift og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 44.1,
    ORDF: 39.2,
  },
  {
    Studiekode: '204 872',
    Studienavn: 'Internasjonale relasjoner, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 877',
    Studienavn: 'Sosiologi og samfunnsanalyse',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 934',
    Studienavn: 'Lektor, 8.-13. trinn, samfunnsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '204 952',
    Studienavn: 'Trening, helse og prestasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '204 955',
    Studienavn: 'Human Resource Management (HRM), Bodø',
    Studiekategori: 'Bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORD: 41.6,
    ORDF: 40.1,
  },
  {
    Studiekode: '209 035',
    Studienavn: 'Økonomi og administrasjon, Lillehammer, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORD: 42.4,
    ORDF: 41.9,
  },
  {
    Studiekode: '209 050',
    Studienavn: 'Sykepleie, Elverum',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 051',
    Studienavn: 'Sykepleie, deltid, Tynset',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Tynset',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 052',
    Studienavn: 'Sykepleie, deltid, Elverum',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 053',
    Studienavn: 'Sykepleie, Kongsvinger',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Kongsvinger',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 43.2,
    ORDF: 31.7,
  },
  {
    Studiekode: '209 061',
    Studienavn: 'Vernepleie, deltid, Lillehammer',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 49.6,
    ORDF: 0,
  },
  {
    Studiekode: '209 062',
    Studienavn: 'Vernepleie, deltid, Kongsvinger',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Kongsvinger',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 50.3,
    ORDF: 0,
  },
  {
    Studiekode: '209 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 40,
    ORDF: 34.1,
  },
  {
    Studiekode: '209 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 44.5,
    ORDF: 39.7,
  },
  {
    Studiekode: '209 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 132',
    Studienavn: 'Barnehagelærer, samlingsbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 162',
    Studienavn: 'Organisasjon og ledelse, Rena',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 164',
    Studienavn: 'Bedriftsøkonomi',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 172',
    Studienavn: 'Jakt, fiske og naturveiledning',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Stor-Elvdal',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 183',
    Studienavn: 'Animasjon og digital kunst',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 185',
    Studienavn: 'Kroppsøving og idrett',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 207',
    Studienavn: 'Bedriftsøkonomi, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 58.6,
    ORDF: 0,
  },
  {
    Studiekode: '209 215',
    Studienavn: 'Offentlig styring, ledelse og økonomi, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 44,
    ORDF: 0,
  },
  {
    Studiekode: '209 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 232',
    Studienavn: 'Økonomi og administrasjon, Lillehammer, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORD: 48.3,
    ORDF: 41.7,
  },
  {
    Studiekode: '209 239',
    Studienavn: 'Krisehåndtering, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'SAMFUNN',
    ORD: 54.7,
    ORDF: 0,
  },
  {
    Studiekode: '209 242',
    Studienavn: 'Samfunnsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 264',
    Studienavn: 'Dokumentar- og TV-produksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'MEDIEFAG',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '209 288',
    Studienavn: 'Internasjonale studier , årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 311',
    Studienavn: 'Landbruksteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 320',
    Studienavn: 'Agronomi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 322',
    Studienavn: 'Skogbruk',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Stor-Elvdal',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 323',
    Studienavn: 'Utmarksforvaltning',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Stor-Elvdal',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 358',
    Studienavn: 'Music Business and Production, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 366',
    Studienavn: 'Filosofi',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 368',
    Studienavn: 'Eiendomsmegling',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '209 369',
    Studienavn: 'Økonomi og administrasjon, Rena, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 389',
    Studienavn: 'Bærekraftsøkonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Kongsvinger',
    Utdanningsområde: 'ØKADM',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '209 395',
    Studienavn: 'Kunstig intelligens',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'INFOTEKN',
    ORD: 47.6,
    ORDF: 0,
  },
  {
    Studiekode: '209 404',
    Studienavn: 'Regnskap og økonomirådgivning, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 54.7,
    ORDF: 0,
  },
  {
    Studiekode: '209 409',
    Studienavn: 'Økologisk landbruk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 437',
    Studienavn: 'Musikkformidling',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 440',
    Studienavn: 'Idrett - spesialisering i trenerrollen',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'IDRETT',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '209 446',
    Studienavn: 'Mat, ernæring og helse',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '209 470',
    Studienavn: 'Serviceledelse og markedsføring',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 479',
    Studienavn: 'Filosofi, politikk og økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 485',
    Studienavn: 'Sport Management',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORD: 37.7,
    ORDF: 34.6,
  },
  {
    Studiekode: '209 486',
    Studienavn: 'Folkehelsearbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 488',
    Studienavn: 'Idrett - spesialisering i trenerrollen, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 489',
    Studienavn: 'Idrettsvitenskap- helse og treningsfysiologi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 507',
    Studienavn: 'Idrett',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 515',
    Studienavn: 'Økonomi og administrasjon, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 53.9,
    ORDF: 0,
  },
  {
    Studiekode: '209 516',
    Studienavn: 'Regnskap og økonomirådgivning',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 525',
    Studienavn: 'Organisasjon og ledelse, Lillehammer',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORD: 37.8,
    ORDF: 36.1,
  },
  {
    Studiekode: '209 526',
    Studienavn: 'Rettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'JUS',
    ORD: 55.7,
    ORDF: 51,
  },
  {
    Studiekode: '209 527',
    Studienavn: 'Bærekraftig reiseliv og arrangement',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'REISELIV',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '209 530',
    Studienavn: 'Beredskap og krisehåndtering',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'SAMFUNN',
    ORD: 53.6,
    ORDF: 0,
  },
  {
    Studiekode: '209 534',
    Studienavn: 'Prosjekt- og prod.ledelse for dokumentar og TV',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'MEDIEFAG',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '209 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 548',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, samlingsbasert',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og Idrettsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 568',
    Studienavn: 'Pedagogikk - fleksibelt, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 575',
    Studienavn: 'Lærer, 1.-13. trinn, musikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 583',
    Studienavn: 'Organisasjon og ledelse, deltid, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 56.1,
    ORDF: 0,
  },
  {
    Studiekode: '209 591',
    Studienavn: 'Bærekraftig reiselivs- og arrangementsledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'REISELIV',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '209 607',
    Studienavn: 'Music Business and Production, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 623',
    Studienavn: 'Engelsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 624',
    Studienavn: 'Spillpedagogikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 646',
    Studienavn: 'Mat, ernæring og helse, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORD: 59.2,
    ORDF: 0,
  },
  {
    Studiekode: '209 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, samlingsbasert',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 664',
    Studienavn: 'Organisasjon og ledelse, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 40,
    ORDF: 0,
  },
  {
    Studiekode: '209 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 672',
    Studienavn: 'Norsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 702',
    Studienavn: 'Bioingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 42.5,
    ORDF: 0,
  },
  {
    Studiekode: '209 703',
    Studienavn: 'Fysioterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORD: 54.3,
    ORDF: 47.8,
  },
  {
    Studiekode: '209 730',
    Studienavn: 'Jordbruk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 733',
    Studienavn: 'Jordbruk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 743',
    Studienavn: 'Tannpleie',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORD: 45.7,
    ORDF: 38.3,
  },
  {
    Studiekode: '209 839',
    Studienavn: 'Spillteknologi og simulering',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 847',
    Studienavn: 'Dokumentar- og TV-regi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'MEDIEFAG',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '209 852',
    Studienavn: 'Pedagogikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 853',
    Studienavn: 'Spesialpedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORD: 40.7,
    ORDF: 33.4,
  },
  {
    Studiekode: '209 867',
    Studienavn: 'Ledelse og digitalisering',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 872',
    Studienavn: 'Internasjonale studier , bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '209 876',
    Studienavn: 'Psykologi',
    Studiekategori: 'Bachelor',
    Lærested: 'HINN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'SAMFUNN',
    ORD: 50.8,
    ORDF: 47.4,
  },
  {
    Studiekode: '209 935',
    Studienavn: 'Lektor, 8.-13. trinn, språkfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HINN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 050',
    Studienavn: 'Sykepleie, Molde',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 42.6,
    ORDF: 34.6,
  },
  {
    Studiekode: '211 061',
    Studienavn: 'Vernepleie, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 38.8,
    ORDF: '',
  },
  {
    Studiekode: '211 164',
    Studienavn: 'Bedriftsøkonomi',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 185',
    Studienavn: 'Idrett og adventure',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 187',
    Studienavn: 'IT, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'INFOTEKN',
    ORD: 53.9,
    ORDF: 0,
  },
  {
    Studiekode: '211 189',
    Studienavn: 'IT',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 218',
    Studienavn: 'Juss og økonomi',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 232',
    Studienavn: 'Organisasjon og personalledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 292',
    Studienavn: 'Logistikk og Supply Chain Management',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 369',
    Studienavn: 'Økonomi og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 389',
    Studienavn: 'Bærekraftig logistikk og sirkulær økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 432',
    Studienavn: 'Marin logistikk og økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 449',
    Studienavn: 'IT og digitalisering',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'INFOTEKN',
    ORD: 45,
    ORDF: 0,
  },
  {
    Studiekode: '211 488',
    Studienavn: 'Sport Management',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 526',
    Studienavn: 'Rettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'JUS',
    ORD: 53.4,
    ORDF: 49.6,
  },
  {
    Studiekode: '211 554',
    Studienavn: 'Paramedisin',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 52.5,
    ORDF: 46.8,
  },
  {
    Studiekode: '211 589',
    Studienavn: 'Sykepleie, Kristiansund',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 627',
    Studienavn: 'Logistikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 841',
    Studienavn: 'Politikk, juss og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '211 866',
    Studienavn: 'Petroleumslogistikk og økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 003',
    Studienavn: 'Ingeniør, bygg',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 004',
    Studienavn: 'Ingeniør, data',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 50.8,
    ORDF: 44.6,
  },
  {
    Studiekode: '215 005',
    Studienavn: 'Ingeniør, elektronikk',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 009',
    Studienavn: 'Ingeniør, bioteknologi og kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 012',
    Studienavn: 'Ingeniør, maskin',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 050',
    Studienavn: 'Sykepleie, Oslo',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 40.2,
    ORDF: 37.8,
  },
  {
    Studiekode: '215 054',
    Studienavn: 'Sykepleie, Kjeller',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 45.9,
    ORDF: 34,
  },
  {
    Studiekode: '215 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 49.3,
    ORDF: 44.1,
  },
  {
    Studiekode: '215 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 53.7,
    ORDF: 46.5,
  },
  {
    Studiekode: '215 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn med steinerpedagogikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 085',
    Studienavn: 'Arkivvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 49.8,
    ORDF: 0,
  },
  {
    Studiekode: '215 105',
    Studienavn: 'Yrkesfaglærer i salg, service og reiseliv',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 109',
    Studienavn: 'Yrkesfaglærer i bygg og anleggsteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 123',
    Studienavn: 'Yrkesfaglærer i helse- og oppvekstfag',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 124',
    Studienavn: 'Yrkesfaglærer i restaurant- og matfag',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 126',
    Studienavn: 'Yrkesfaglærer i håndverk, design og prod.utvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 127',
    Studienavn: 'Yrkesfaglærer i elektro og datateknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 129',
    Studienavn: 'Yrkesfaglærer i teknologi og industrifag',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 131',
    Studienavn: 'Barnehagelærer, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 138',
    Studienavn: 'Administrasjon og ledelse i offentlig virksomhet',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 51.1,
    ORDF: 45.7,
  },
  {
    Studiekode: '215 162',
    Studienavn: 'Økonomi og ledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 63.5,
    ORDF: 50.1,
  },
  {
    Studiekode: '215 200',
    Studienavn: 'Kunst og design - studieretn. kunst og formidling',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 49.1,
    ORDF: 35.3,
  },
  {
    Studiekode: '215 221',
    Studienavn: 'Tegnspråk',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 47,
    ORDF: 0,
  },
  {
    Studiekode: '215 242',
    Studienavn: 'Migrasjons- og integrasjonsforvaltning',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 43.9,
    ORDF: 0,
  },
  {
    Studiekode: '215 253',
    Studienavn: 'Økonomi og ledelse, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 61.9,
    ORDF: 46.9,
  },
  {
    Studiekode: '215 336',
    Studienavn: 'Bibliotek- og informasjonsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 55.8,
    ORDF: 50.3,
  },
  {
    Studiekode: '215 369',
    Studienavn: 'Økonomi og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 52.2,
    ORDF: 48.3,
  },
  {
    Studiekode: '215 395',
    Studienavn: 'Informasjonsteknologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 54.6,
    ORDF: 41,
  },
  {
    Studiekode: '215 405',
    Studienavn: 'Produktdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'ESTETISK',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '215 439',
    Studienavn: 'Drama og teaterkommunikasjon, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 449',
    Studienavn: 'Anvendt datateknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 54.2,
    ORDF: 42.7,
  },
  {
    Studiekode: '215 454',
    Studienavn: 'Journalistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 57.2,
    ORDF: 49.5,
  },
  {
    Studiekode: '215 466',
    Studienavn: 'Norsk tegnspråk',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 472',
    Studienavn: 'Kunst og design - studieretn. mote og produksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 57,
    ORDF: 51.9,
  },
  {
    Studiekode: '215 484',
    Studienavn: 'Utviklingsstudier, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 44.8,
    ORDF: 40.9,
  },
  {
    Studiekode: '215 503',
    Studienavn: 'Ingeniør, matematisk modellering og datavitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 528',
    Studienavn: 'Dokumentasjonsforvaltning, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 52.6,
    ORDF: 0,
  },
  {
    Studiekode: '215 533',
    Studienavn: 'Yrkesfaglærer i informasjonstekn. og medieprod.',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 535',
    Studienavn: 'Yrkesfaglærer i frisør, blomster, interiør, ekspd.',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 554',
    Studienavn: 'Paramedisin',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 54.9,
    ORDF: 47.8,
  },
  {
    Studiekode: '215 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og idrettsfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 574',
    Studienavn: 'Lærer, 1.-13. trinn, design, kunst og håndverk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 602',
    Studienavn: 'Design og kommunikasjon i digitale medier, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 57,
    ORDF: 40.8,
  },
  {
    Studiekode: '215 603',
    Studienavn: 'Bibliotek- og informasjonsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 57.1,
    ORDF: 0,
  },
  {
    Studiekode: '215 604',
    Studienavn: 'Medier og kommunikasjon, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 61.7,
    ORDF: 47.5,
  },
  {
    Studiekode: '215 618',
    Studienavn: 'Drama og teaterkommunikasjon, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: 52.3,
    ORDF: 45.4,
  },
  {
    Studiekode: '215 620',
    Studienavn: 'Informasjonsteknologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORD: 60.5,
    ORDF: 41.4,
  },
  {
    Studiekode: '215 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, norsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 655',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, engelsk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 657',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, matematikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 691',
    Studienavn: 'Utviklingsstudier, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 49.5,
    ORDF: 36.5,
  },
  {
    Studiekode: '215 696',
    Studienavn: 'Trafikklærer',
    Studiekategori: 'Kandidatstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - ANNET',
    ORD: -2,
    ORDF: '',
  },
  {
    Studiekode: '215 700',
    Studienavn: 'Ergoterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORD: 46.7,
    ORDF: 38.5,
  },
  {
    Studiekode: '215 701',
    Studienavn: 'Radiografi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORD: 54.3,
    ORDF: 45.4,
  },
  {
    Studiekode: '215 702',
    Studienavn: 'Bioingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 52.8,
    ORDF: 45.1,
  },
  {
    Studiekode: '215 703',
    Studienavn: 'Fysioterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORD: 54.5,
    ORDF: 48.1,
  },
  {
    Studiekode: '215 744',
    Studienavn: 'Ortopediingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ORTOPEDI',
    ORD: 57.6,
    ORDF: 48.3,
  },
  {
    Studiekode: '215 749',
    Studienavn: 'Farmasi',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - RESEPTAR',
    ORD: 49.8,
    ORDF: 37.7,
  },
  {
    Studiekode: '215 822',
    Studienavn: 'Ingeniør, energi og miljø i bygg',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '215 848',
    Studienavn: 'Fotojournalistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 66.8,
    ORDF: 0,
  },
  {
    Studiekode: '215 850',
    Studienavn: 'Medier og kommunikasjon, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 53.5,
    ORDF: 48.2,
  },
  {
    Studiekode: '215 876',
    Studienavn: 'Psykologi med vekt på adferdsanalyse',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'SAMFUNN',
    ORD: 50.6,
    ORDF: 44.7,
  },
  {
    Studiekode: '215 953',
    Studienavn: 'Yrkesfaglærer i bygg og anleggsteknikk, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 954',
    Studienavn: 'Yrkesfaglærer i elektro og datateknologi, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '215 958',
    Studienavn: 'Yrkesfaglærer i teknologi og industrifag, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORD: 0,
    ORDF: '',
  },
  {
    Studiekode: '217 004',
    Studienavn: 'Ingeniør, datateknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 005',
    Studienavn: 'Ingeniør, elektroteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 009',
    Studienavn: 'Ingeniør, teknisk miljøvern',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 012',
    Studienavn: 'Ingeniør, maskin',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 015',
    Studienavn: 'Ingeniør, energi- og petroleumsteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 033',
    Studienavn: 'Ingeniør, bygg, studieretning infrastruktur',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 046',
    Studienavn: 'Fjernsyns- og multimedieproduksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 44,
    ORDF: 40,
  },
  {
    Studiekode: '217 050',
    Studienavn: 'Sykepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 067',
    Studienavn: 'Ingeniør, bygg, studieretning byplanlegging',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 41.1,
    ORDF: 39.5,
  },
  {
    Studiekode: '217 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 46.5,
    ORDF: 44.3,
  },
  {
    Studiekode: '217 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 131',
    Studienavn: 'Barnehagelærer, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 170',
    Studienavn: 'Engelsk språk og litteratur, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 177',
    Studienavn: 'Kommunikasjon',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 50.7,
    ORDF: 29,
  },
  {
    Studiekode: '217 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 196',
    Studienavn: 'Religion, kultur og samfunn, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 205',
    Studienavn: 'Matematikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 211',
    Studienavn: 'Nordisk språk og litteratur, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 218',
    Studienavn: 'Økonomi og ledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ØKADM',
    ORD: 55.6,
    ORDF: 47.4,
  },
  {
    Studiekode: '217 233',
    Studienavn: 'Realfag og teknologi',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 255',
    Studienavn: 'Hotelledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 317',
    Studienavn: 'Reiselivsledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 369',
    Studienavn: 'Økonomi og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ØKADM',
    ORD: 46.1,
    ORDF: 45,
  },
  {
    Studiekode: '217 440',
    Studienavn: 'Idrettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'IDRETT',
    ORD: 32.9,
    ORDF: 36.3,
  },
  {
    Studiekode: '217 454',
    Studienavn: 'Journalistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 47.7,
    ORDF: 45.3,
  },
  {
    Studiekode: '217 470',
    Studienavn: 'Digital serviceledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORD: 43.3,
    ORDF: 41.4,
  },
  {
    Studiekode: '217 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 482',
    Studienavn: 'Religion, kultur og samfunn, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 526',
    Studienavn: 'Rettsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'JUS',
    ORD: 59.1,
    ORDF: 53.2,
  },
  {
    Studiekode: '217 530',
    Studienavn: 'Byplanlegging og samfunnssikkerhet',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 47.1,
    ORDF: 43,
  },
  {
    Studiekode: '217 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 554',
    Studienavn: 'Paramedisin',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 57.6,
    ORDF: 52.2,
  },
  {
    Studiekode: '217 618',
    Studienavn: 'Drama- og teaterkommunikasjon',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 642',
    Studienavn: 'Kunst og håndverk',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ESTETISK',
    ORD: 51,
    ORDF: 39.5,
  },
  {
    Studiekode: '217 649',
    Studienavn: 'Idrett',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'IDRETT',
    ORD: 49.6,
    ORDF: 44.8,
  },
  {
    Studiekode: '217 667',
    Studienavn: 'Musikkopplæring',
    Studiekategori: 'Årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 675',
    Studienavn: 'Ingeniør, bygg, studieretning konstruksjonsteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 747',
    Studienavn: 'Matematikk og fysikk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 760',
    Studienavn: 'Datateknologi',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 813',
    Studienavn: 'Industriell økonomi, alle linjer',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - SIVING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 822',
    Studienavn: 'Ingeniør, batteri- og energiteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 844',
    Studienavn: 'Lektor, 8.-13. trinn, humanistiske fag',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 852',
    Studienavn: 'Skolefritidspedagogikk, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'PEDFAG',
    ORD: 43.5,
    ORDF: 0,
  },
  {
    Studiekode: '217 860',
    Studienavn: 'Biologisk kjemi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 876',
    Studienavn: 'Psykologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 53.8,
    ORDF: 48.2,
  },
  {
    Studiekode: '217 880',
    Studienavn: 'Sosiologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 35.8,
    ORDF: 33.4,
  },
  {
    Studiekode: '217 881',
    Studienavn: 'Statsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 43,
    ORDF: 43,
  },
  {
    Studiekode: '217 887',
    Studienavn: 'Engelsk språk og litteratur, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 889',
    Studienavn: 'Nordisk språk og litteratur, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '217 906',
    Studienavn: 'Toll, vareførsel og grensekontroll',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'JUS',
    ORD: 58,
    ORDF: 50.5,
  },
  {
    Studiekode: '217 956',
    Studienavn: 'Ingeniør, medisinsk teknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 003',
    Studienavn: 'Ingeniør, bygg - konstruksjon og byggdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 004',
    Studienavn: 'Ingeniør, data - cybersikkerhet',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 006',
    Studienavn: 'Ingeniør, elektro - elkraft og bærekraftig energi',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 012',
    Studienavn: 'Ingeniør, maskin - produktdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 017',
    Studienavn: 'Ingeniør, elektro - elektro-automasjon og robotikk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 033',
    Studienavn: 'Ingeniør, bygg - plan og infrastruktur',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 044',
    Studienavn: 'Skipsfart og logistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORD: 48.1,
    ORDF: 43.5,
  },
  {
    Studiekode: '222 050',
    Studienavn: 'Sykepleie, Vestfold',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 051',
    Studienavn: 'Sykepleie, Drammen',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 054',
    Studienavn: 'Sykepleie, Porsgrunn',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 059',
    Studienavn: 'Sykepleie, deltid, Vestfold og Telemark',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 53.8,
    ORDF: 0,
  },
  {
    Studiekode: '222 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 47.4,
    ORDF: 31.8,
  },
  {
    Studiekode: '222 068',
    Studienavn: 'Ingeniør, elektronikk - kybernetikk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 069',
    Studienavn: 'Ingeniør, maskin - produktutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 42.9,
    ORDF: 36.5,
  },
  {
    Studiekode: '222 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Drammen',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Notodden',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 090',
    Studienavn: 'Ingeniør, elektro - informatikk og automatisering',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 097',
    Studienavn: 'Bedriftsøkonomi, Ringerike',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 098',
    Studienavn: 'Design i nye medier',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 48.7,
    ORDF: 0,
  },
  {
    Studiekode: '222 130',
    Studienavn: 'Barnehagelærer, Vestfold',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 131',
    Studienavn: 'Barnehagelærer, deltid, Vestfold',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 132',
    Studienavn: 'Barnehagelærer, Drammen',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 133',
    Studienavn: 'Barnehagelærer, Porsgrunn',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 134',
    Studienavn: 'Barnehagelærer, deltid, Notodden',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 155',
    Studienavn: 'Arkitektonisk lysdesign',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 164',
    Studienavn: 'Bedriftsøkonomi, Bø',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 172',
    Studienavn: 'Friluftsliv',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 179',
    Studienavn: 'Historie, Vestfold, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 185',
    Studienavn: 'Idrett',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 188',
    Studienavn: 'IT og informasjonssystemer, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 189',
    Studienavn: 'IT og informasjonssystemer, Hallingdal',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 210',
    Studienavn: 'Norsk, Vestfold',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 218',
    Studienavn: 'Bedriftsøkonomi, Hallingdal',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 240',
    Studienavn: 'Sosiologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SAMFUNN',
    ORD: 44.3,
    ORDF: 0,
  },
  {
    Studiekode: '222 251',
    Studienavn: 'Visuell kommunikasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 47.5,
    ORDF: 39.6,
  },
  {
    Studiekode: '222 302',
    Studienavn: 'Friluftslivveiledning',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 308',
    Studienavn: 'Kulturledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 315',
    Studienavn: 'Natur- og miljøforvaltning',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 330',
    Studienavn: 'Økonomi og ledelse, Drammen',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'ØKADM',
    ORD: 44.5,
    ORDF: 40.1,
  },
  {
    Studiekode: '222 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 351',
    Studienavn: 'Ungdomskunnskap',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 352',
    Studienavn: 'Marinteknisk drift',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORD: 42,
    ORDF: 32.5,
  },
  {
    Studiekode: '222 353',
    Studienavn: 'Nautikk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORD: 45,
    ORDF: 36.7,
  },
  {
    Studiekode: '222 359',
    Studienavn: 'Markedsføringsledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 366',
    Studienavn: 'Idéhistorie',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 368',
    Studienavn: 'Eiendomsmegling',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORD: 38.5,
    ORDF: 38.5,
  },
  {
    Studiekode: '222 369',
    Studienavn: 'Økonomi og ledelse, Vestfold',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'ØKADM',
    ORD: 43,
    ORDF: 37.6,
  },
  {
    Studiekode: '222 395',
    Studienavn: 'IT og informasjonssystemer, Ringerike',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'INFOTEKN',
    ORD: 41.2,
    ORDF: 0,
  },
  {
    Studiekode: '222 398',
    Studienavn: 'Bedriftsøkonomi, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 404',
    Studienavn: 'Økonomi og ledelse, Kongsberg',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 412',
    Studienavn: 'Informasjonsbehandling',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'INFOTEKN',
    ORD: 53.7,
    ORDF: 0,
  },
  {
    Studiekode: '222 414',
    Studienavn: 'Økonomi og ledelse, Ringerike',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 440',
    Studienavn: 'Fysisk aktivitet, ernæring og helse',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 442',
    Studienavn: 'Tradisjonskunst; tre, metall eller tekstilhåndverk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 443',
    Studienavn: 'Folkemusikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 449',
    Studienavn: 'IT og informasjonssystemer, Bø',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 455',
    Studienavn: 'Språk og litteratur - spansk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 456',
    Studienavn: 'Språk og litteratur - engelsk, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 44.7,
    ORDF: -1,
  },
  {
    Studiekode: '222 468',
    Studienavn: 'Innovasjon og bærekraft',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 470',
    Studienavn: 'Økonomi og ledelse, Bø',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 471',
    Studienavn: 'Kunst og design - håndverk og design',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 474',
    Studienavn: 'Språk og litteratur - norsk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 481',
    Studienavn: 'Historie, Vestfold, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 488',
    Studienavn: 'Idrett, trening og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 503',
    Studienavn: 'Ingeniør, data - cyber physical systems',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 513',
    Studienavn: 'Historie, Bø, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 521',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Hallingdal',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 526',
    Studienavn: 'Jus',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'JUS',
    ORD: 54,
    ORDF: 49.5,
  },
  {
    Studiekode: '222 529',
    Studienavn: 'Barnehagelærer, Notodden',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Vestfold',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 548',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Drammen',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 557',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Porsgrunn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 567',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Notodden',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 569',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Porsgrunn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '222 573',
    Studienavn: 'Håndverk og design',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 574',
    Studienavn: 'Lærer, 1.-13. trinn, design, kunst og håndverk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 589',
    Studienavn: 'Sykepleie, deltid, Hallingdal',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 602',
    Studienavn: 'Digital mediedesign',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 55.1,
    ORDF: 0,
  },
  {
    Studiekode: '222 605',
    Studienavn: 'Natur og miljø',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 606',
    Studienavn: 'Engelsk, Bø',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 48.8,
    ORDF: 0,
  },
  {
    Studiekode: '222 613',
    Studienavn: 'Historie, Bø, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 622',
    Studienavn: 'Engelsk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 53.9,
    ORDF: 0,
  },
  {
    Studiekode: '222 623',
    Studienavn: 'Engelsk, Vestfold',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 628',
    Studienavn: 'Tradisjonskunst: tre, metall eller tekstilhåndverk',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 629',
    Studienavn: 'Folkemusikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 637',
    Studienavn: 'Tegning - bilde og form',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 642',
    Studienavn: 'Kunst og design',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 649',
    Studienavn: 'Kroppsøving og idrettsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Vestfold',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 672',
    Studienavn: 'Norsk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 51.4,
    ORDF: -1,
  },
  {
    Studiekode: '222 684',
    Studienavn: 'Lektor, historie, 8.-13. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 688',
    Studienavn: 'Ingeniør, kjemi - ren energi- og prosessteknologi',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 699',
    Studienavn: 'Ingeniør, elektronikk-mikroteknologi og datasystem',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 701',
    Studienavn: 'Radiografi',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORD: 51.3,
    ORDF: 43.1,
  },
  {
    Studiekode: '222 715',
    Studienavn: 'Historie, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORD: 44.8,
    ORDF: 0,
  },
  {
    Studiekode: '222 716',
    Studienavn: 'Utøvende folkedans',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '222 717',
    Studienavn: 'Internasjonal forståelse og samarbeid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 781',
    Studienavn: 'Kunst og design - visuell kunst',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 824',
    Studienavn: 'Ingeniør, maskin - konstruksjonsteknikk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 845',
    Studienavn: 'Kunst og design - digital mediedesign',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORD: 57.3,
    ORDF: 38.5,
  },
  {
    Studiekode: '222 853',
    Studienavn: 'Spesialpedagogikk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 867',
    Studienavn: 'Forretningsjus og økonomi',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'JUS',
    ORD: 39.6,
    ORDF: 41.6,
  },
  {
    Studiekode: '222 880',
    Studienavn: 'Sosiologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 881',
    Studienavn: 'Statsvitenskap',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 41.8,
    ORDF: 40.1,
  },
  {
    Studiekode: '222 885',
    Studienavn: 'Språk og formidling',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '222 894',
    Studienavn: 'Optometri',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORD: 40.6,
    ORDF: 0,
  },
  {
    Studiekode: '222 912',
    Studienavn: 'Spansk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 59.1,
    ORDF: -1,
  },
  {
    Studiekode: '222 913',
    Studienavn: 'Spansk',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 54.3,
    ORDF: 0,
  },
  {
    Studiekode: '222 922',
    Studienavn: 'Språk og litteratur - engelsk',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 43.1,
    ORDF: 0,
  },
  {
    Studiekode: '222 924',
    Studienavn: 'Språk og litteratur - spansk, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 950',
    Studienavn: 'Norsk, Bø',
    Studiekategori: 'Årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 51.9,
    ORDF: 0,
  },
  {
    Studiekode: '222 954',
    Studienavn: 'Språk og litteratur - norsk, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '222 955',
    Studienavn: 'IT og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'INFOTEKN',
    ORD: 46.3,
    ORDF: 34.7,
  },
  {
    Studiekode: '222 956',
    Studienavn: 'Ingeniør, data - softwareutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 070',
    Studienavn: 'Sosialt arbeid, barnevernspedagog',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 080',
    Studienavn: 'Sosialt arbeid, sosionom',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 170',
    Studienavn: 'Engelsk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 179',
    Studienavn: 'Historie, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 210',
    Studienavn: 'Norsk (nordisk)',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 211',
    Studienavn: 'Norsk (nordisk), deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 285',
    Studienavn: 'Samfunnskunnskap',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 437',
    Studienavn: 'Musikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 439',
    Studienavn: 'Teater og drama, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 440',
    Studienavn: 'Friluftsliv og naturguide',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 451',
    Studienavn: 'Animasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 452',
    Studienavn: 'Samfunnsutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 453',
    Studienavn: 'PR, kommunikasjon og media',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 37.7,
    ORDF: 36.2,
  },
  {
    Studiekode: '223 454',
    Studienavn: 'Journalistikk',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 48.4,
    ORDF: 46.7,
  },
  {
    Studiekode: '223 472',
    Studienavn: 'Design, kunst og håndverk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 481',
    Studienavn: 'Historie, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 485',
    Studienavn: 'Idrett og kroppsøving, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 513',
    Studienavn: 'Historie, bachelor, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 529',
    Studienavn: 'Barnehagelærer, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 605',
    Studienavn: 'Friluftsliv',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 618',
    Studienavn: 'Teater og drama, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 623',
    Studienavn: 'Engelsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 630',
    Studienavn: 'Design, kunst og håndverk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 649',
    Studienavn: 'Idrett og kroppsøving, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 667',
    Studienavn: 'Musikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 845',
    Studienavn: 'Medieproduksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 46.1,
    ORDF: 41.8,
  },
  {
    Studiekode: '223 891',
    Studienavn: 'Språk og litteratur',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '223 902',
    Studienavn: 'Religion og kultur',
    Studiekategori: 'Bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 003',
    Studienavn: 'Ingeniør, bygg og miljø',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 004',
    Studienavn: 'Ingeniør, data',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 005',
    Studienavn: 'Ingeniør, elektro: elektronikk og grønn energi',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 012',
    Studienavn: 'Ingeniør, maskin: industriell produktutvikling',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '224 035',
    Studienavn: 'Økonomi og administrasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 050',
    Studienavn: 'Sykepleie, Fredrikstad',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 052',
    Studienavn: 'Sykepleie, Indre Østfold',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Indre Østfold',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 44.5,
    ORDF: 32.5,
  },
  {
    Studiekode: '224 070',
    Studienavn: 'Barnevern',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORD: 44.7,
    ORDF: 38.9,
  },
  {
    Studiekode: '224 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 49,
    ORDF: 42,
  },
  {
    Studiekode: '224 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 131',
    Studienavn: 'Barnehagelærer, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 170',
    Studienavn: 'Engelsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 174',
    Studienavn: 'Fransk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 210',
    Studienavn: 'Norsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 244',
    Studienavn: 'Tysk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 270',
    Studienavn: 'Informatikk: design og utvikling av IT-systemer',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 398',
    Studienavn: 'Bedriftsøkonomi',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 453',
    Studienavn: 'Informasjonssystemer',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORD: 46,
    ORDF: 32.3,
  },
  {
    Studiekode: '224 455',
    Studienavn: 'Internasjonal kommunikasjon',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 505',
    Studienavn: 'Kunst og håndverk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 516',
    Studienavn: 'Regnskap',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 610',
    Studienavn: 'Fransk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 620',
    Studienavn: 'Informasjonsteknologi',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 626',
    Studienavn: 'Religion, livssyn og etikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 649',
    Studienavn: 'Kroppsøving og idrett',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'IDRETT',
    ORD: 35,
    ORDF: 37.7,
  },
  {
    Studiekode: '224 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 661',
    Studienavn: 'Matematikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 666',
    Studienavn: 'Naturfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 680',
    Studienavn: 'Samfunnsfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 690',
    Studienavn: 'Tysk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 702',
    Studienavn: 'Bioingeniør',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 845',
    Studienavn: 'Digitale medier og design',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORD: 34.5,
    ORDF: 0,
  },
  {
    Studiekode: '224 895',
    Studienavn: 'Innovasjon og prosjektledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - ANNET',
    ORD: 33.5,
    ORDF: 0,
  },
  {
    Studiekode: '224 901',
    Studienavn: 'Språk (engelsk/fransk/spansk/tysk)',
    Studiekategori: 'Bachelor',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '224 912',
    Studienavn: 'Spansk',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 47.8,
    ORDF: 0,
  },
  {
    Studiekode: '224 913',
    Studienavn: 'Spansk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORD: 47.4,
    ORDF: 0,
  },
  {
    Studiekode: '230 050',
    Studienavn: 'Sykepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'LDH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 50.5,
    ORDF: 45,
  },
  {
    Studiekode: '231 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, samisk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '231 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, samisk',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '233 679',
    Studienavn: 'Politiutdanning, Stavern',
    Studiekategori: 'Bachelor',
    Lærested: 'PHS',
    Studiested: 'Larvik',
    Utdanningsområde: 'JUS',
    ORD: 50.7,
    ORDF: '',
  },
  {
    Studiekode: '233 681',
    Studienavn: 'Politiutdanning, Oslo',
    Studiekategori: 'Bachelor',
    Lærested: 'PHS',
    Studiested: 'Oslo',
    Utdanningsområde: 'JUS',
    ORD: 52.1,
    ORDF: '',
  },
  {
    Studiekode: '233 682',
    Studienavn: 'Politiutdanning, Bodø',
    Studiekategori: 'Bachelor',
    Lærested: 'PHS',
    Studiested: 'Bodø',
    Utdanningsområde: 'JUS',
    ORD: 46.1,
    ORDF: '',
  },
  {
    Studiekode: '251 050',
    Studienavn: 'Sykepleie, Oslo',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '251 055',
    Studienavn: 'Sykepleie, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 45.5,
    ORDF: 43.8,
  },
  {
    Studiekode: '251 059',
    Studienavn: 'Sykepleie, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Bærum',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORD: 46.6,
    ORDF: 0,
  },
  {
    Studiekode: '251 060',
    Studienavn: 'Vernepleie',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 41,
    ORDF: 30,
  },
  {
    Studiekode: '251 061',
    Studienavn: 'Vernepleie, deltid, Stavanger',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 45.5,
    ORDF: 0,
  },
  {
    Studiekode: '251 063',
    Studienavn: 'Vernepleie, deltid, Sandvika',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Bærum',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORD: 51.7,
    ORDF: 31,
  },
  {
    Studiekode: '251 080',
    Studienavn: 'Sosialt arbeid',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 50.7,
    ORDF: 43.2,
  },
  {
    Studiekode: '251 081',
    Studienavn: 'Sosialt arbeid, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORD: 44.3,
    ORDF: '',
  },
  {
    Studiekode: '251 162',
    Studienavn: 'Verdibasert ledelse og administrasjon',
    Studiekategori: 'Årsstudium',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 46,
    ORDF: 0,
  },
  {
    Studiekode: '251 220',
    Studienavn: 'Pedagogikk og bærekraft',
    Studiekategori: 'Årsstudium',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'PEDFAG',
    ORD: 44.1,
    ORDF: 0,
  },
  {
    Studiekode: '251 480',
    Studienavn: 'Teologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '251 502',
    Studienavn: 'Sosial bærekraft',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '251 700',
    Studienavn: 'Ergoterapi',
    Studiekategori: 'Bachelor',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORD: 40.6,
    ORDF: 35,
  },
  {
    Studiekode: '251 771',
    Studienavn: 'Teologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '251 791',
    Studienavn: 'Interkulturell kompetanse og bærekraft',
    Studiekategori: 'Årsstudium',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: -1,
  },
  {
    Studiekode: '253 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '253 131',
    Studienavn: 'Barnehagelærer, musikk, drama, kunst og håndverk',
    Studiekategori: 'Bachelor',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '253 132',
    Studienavn: 'Barnehagelærer, natur- og friluftsliv',
    Studiekategori: 'Bachelor',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '253 133',
    Studienavn: 'Barnehagelærer, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '253 134',
    Studienavn: 'Barnehagelærer, ledelse, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'DMMH',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '253 529',
    Studienavn: 'Barnehagelærer, flerkulturell forståelse',
    Studiekategori: 'Bachelor',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '254 035',
    Studienavn: 'Økonomi og administrasjon, Kristiansand',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORD: 32.4,
    ORDF: 36.3,
  },
  {
    Studiekode: '254 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, kroppsøving, Oslo',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 088',
    Studienavn: 'Kommunikasjon, livssyn, kristen apologetikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 130',
    Studienavn: 'Barnehagelærer',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 131',
    Studienavn: 'Barnehagelærer, deltid, Oslo',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 170',
    Studienavn: 'Engelsk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 185',
    Studienavn: 'Idrettsvitenskap, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 195',
    Studienavn: 'Praktisk teologi og ledelse, Bergen',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 196',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE), Bergen',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '254 201',
    Studienavn: 'Lovsangsledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '254 210',
    Studienavn: 'Norsk, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 242',
    Studienavn: 'Samfunnsfag, Bergen',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 285',
    Studienavn: 'Samfunnsfag, Oslo',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 329',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE), Oslo',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 359',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 46.3,
    ORDF: 45.1,
  },
  {
    Studiekode: '254 364',
    Studienavn: 'Utøvende musikk og musikkdidaktikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '254 367',
    Studienavn: 'Interkulturell kompetanse, Bergen, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 393',
    Studienavn: 'Bærekraftig entreprenørskap og innovasjon, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 46,
    ORDF: 0,
  },
  {
    Studiekode: '254 440',
    Studienavn: 'Idrettsvitenskap, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'IDRETT',
    ORD: 36.5,
    ORDF: 38.3,
  },
  {
    Studiekode: '254 454',
    Studienavn: 'Journalistikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 470',
    Studienavn: 'Økonomi og administrasjon, Oslo',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 41.2,
    ORDF: 40.7,
  },
  {
    Studiekode: '254 480',
    Studienavn: 'Teologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 507',
    Studienavn: 'Kroppsøving, Oslo',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 508',
    Studienavn: 'Kroppsøving, Bergen',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'IDRETT',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '254 515',
    Studienavn: 'Økonomi og administrasjon, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORD: 48.2,
    ORDF: 46.4,
  },
  {
    Studiekode: '254 517',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, kroppsøving, Bergen',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 525',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Kristiansand',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORD: 31.4,
    ORDF: 35.5,
  },
  {
    Studiekode: '254 529',
    Studienavn: 'Barnehagelærer, deltid, Bergen',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Bergen',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 550',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Oslo',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 553',
    Studienavn: 'Bibelen, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 604',
    Studienavn: 'Journalistikk, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 642',
    Studienavn: 'Kunst og håndverk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Bergen',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 652',
    Studienavn: 'Praktisk teologi og ledelse, Oslo',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 653',
    Studienavn: 'Praktisk teologi og ledelse, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 654',
    Studienavn:
      'Interkulturell kompetanse, Kristiansand, årsstudium, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 656',
    Studienavn: 'Utøvende musikk, korledelse',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '254 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Oslo',
    Studiekategori: 'Integrert masterstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 662',
    Studienavn: 'Naturfag',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 667',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 771',
    Studienavn: 'Teologi, profesjonsstudium',
    Studiekategori: 'Profesjonsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 777',
    Studienavn: 'Utøvende musikk, fordypning i låtskriving',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORD: -1,
    ORDF: -1,
  },
  {
    Studiekode: '254 789',
    Studienavn: 'Interkulturell kompetanse, Kristiansand, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 852',
    Studienavn: 'Pedagogikk, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 853',
    Studienavn: 'Pedagogikk med vekt på spesped og interkult. ped.',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 872',
    Studienavn: 'Interkulturell kompetanse, Kristiansand, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 877',
    Studienavn: 'Interkulturell kompetanse, Kristiansand, bachelor, nettbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 879',
    Studienavn: 'Interkulturell kompetanse, Bergen, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 895',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Oslo',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORD: 41.2,
    ORDF: 40.8,
  },
  {
    Studiekode: '254 910',
    Studienavn:
      'Kristendom, religion, livssyn og etikk (KRLE), Bergen, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '254 936',
    Studienavn: 'Praktisk teologi og ledelse, Trondheim',
    Studiekategori: 'Bachelor',
    Lærested: 'NLA',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 195',
    Studienavn: 'Teologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 202',
    Studienavn: 'Miljøterapi i et mangfoldig samfunn',
    Studiekategori: 'Årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 418',
    Studienavn: 'Bærekraft og kultur',
    Studiekategori: 'Årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 480',
    Studienavn: 'Teologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 525',
    Studienavn: 'Musikk, menighet og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: -2,
    ORDF: -2,
  },
  {
    Studiekode: '255 536',
    Studienavn: 'Teologi, deltid',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 714',
    Studienavn: 'Musikk og musikkproduksjon',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 752',
    Studienavn: 'Psykologi, årsstudium',
    Studiekategori: 'Årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 52.1,
    ORDF: 46.4,
  },
  {
    Studiekode: '255 777',
    Studienavn: 'Musikk',
    Studiekategori: 'Årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 792',
    Studienavn: 'Musikk og helse',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 869',
    Studienavn: 'Interkulturelle relasjoner',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '255 903',
    Studienavn: 'Psykologi, bachelor',
    Studiekategori: 'Bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORD: 45.6,
    ORDF: 44.8,
  },
  {
    Studiekode: '258 195',
    Studienavn: 'Bibel og misjon',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 196',
    Studienavn: 'Teologi',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 329',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE)',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 418',
    Studienavn: 'Integrering, kultur og religion',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 480',
    Studienavn: 'Teologi og misjon',
    Studiekategori: 'Bachelor',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 539',
    Studienavn: 'Teologi og sjelesorg',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 652',
    Studienavn: 'Teologi, nettbasert',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 653',
    Studienavn: 'Teologi, deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 910',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE), deltid',
    Studiekategori: 'Årsstudium',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 929',
    Studienavn: 'Teologi og misjon, samlingsbasert',
    Studiekategori: 'Bachelor',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
  {
    Studiekode: '258 936',
    Studienavn: 'Teologi, formidling og ledelse',
    Studiekategori: 'Bachelor',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORD: 0,
    ORDF: 0,
  },
]

export default fieldsOfStudy
